/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(28)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tether__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tether__);
function observeDOM(t,e,n){var i=window.MutationObserver||window.WebKitMutationObserver,s=window.addEventListener;if(i){var o=new i(function(t){(t[0].addedNodes.length>0||t[0].removedNodes.length>0)&&e()});o.observe(t,Object.assign({childList:!0,subtree:!0},n))}else s&&(t.addEventListener("DOMNodeInserted",e,!1),t.addEventListener("DOMNodeRemoved",e,!1))}function targets(t,e,n,i){var s=t.__vue__;if(!s)return void console.warn("__vue__ is not available on element",t);var o=Object.keys(e.modifiers||{}).filter(function(t){return!all_listen_types[t]});e.value&&o.push(e.value);var r=function(){i({targets:o,vm:s})};Object.keys(all_listen_types).forEach(function(i){(n[i]||e.modifiers[i])&&t.addEventListener(i,r)})}function isElement(t){return t.nodeType}function closest(t,e){var n=t.closest(e);return n===t?null:n}function $QSA(t,e){return e||(e=document),isElement(e)?Array.prototype.slice.call(e.querySelectorAll(t)):[]}function $QS(t,e){return e||(e=document),isElement(e)?e.querySelector(t)||null:null}function getVm(t){return t?t.__vue__:null}function toType(t){return{}.toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase()}function typeCheckConfig(t,e,n){for(var i in n)if(Object.prototype.hasOwnProperty.call(n,i)){var s=n[i],o=e[i],r=o&&isElement(o)?"element":toType(o);new RegExp(s).test(r)||console.error(t+': Option "'+i+'" provided type "'+r+'" but expected type "'+s+'"')}}function ScrollSpy(t,e){this._$el=t,this._selector=[Selector.NAV_LINKS,Selector.LIST_ITEMS,Selector.DROPDOWN_ITEMS].join(","),this._config=Object.assign({},Default),this._offsets=[],this._targets=[],this._activeTarget=null,this._scrollHeight=0,this._$root=null,this._resizeTimeout=null,this.updateConfig(e)}var alert={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return t.localShow?n("div",{class:t.classObject,attrs:{role:"alert","aria-live":"polite","aria-atomic":"true"}},[t.dismissible?n("button",{staticClass:"close",attrs:{type:"button","data-dismiss":"alert","aria-label":"dismissLabel"},on:{click:function(e){e.stopPropagation(),e.preventDefault(),t.dismiss(e)}}},[n("span",{attrs:{"aria-hidden":"true"}},[t._v("×")])]):t._e(),t._t("default")],2):t._e()},staticRenderFns:[],data:function(){return{countDownTimerId:null,dismissed:!1}},created:function(){this.state&&console.warn("<b-alrt> state property is deprecated, please use variant instead.")},computed:{classObject:function(){return["alert",this.alertVariant,this.dismissible?"alert-dismissible":""]},alertVariant:function(){var t=this.state||this.variant||"info";return"alert-"+t},localShow:function(){return!this.dismissed&&(this.countDownTimerId||this.show)}},props:{variant:{type:String,default:"info"},state:{type:String,default:null},dismissible:{type:Boolean,default:!1},dismissLabel:{type:String,default:"Close"},show:{type:[Boolean,Number],default:!1}},watch:{show:function(){this.showChanged()}},mounted:function(){this.showChanged()},methods:{dismiss:function(){this.dismissed=!0,this.$emit("dismissed"),this.clearCounter()},clearCounter:function(){this.countDownTimerId&&clearInterval(this.countDownTimerId)},showChanged:function(){var t=this;if(this.dismissed=!1,this.show!==!0&&this.show!==!1&&null!==this.show&&0!==this.show){var e=this.show;this.$emit("dismiss-count-down",e),this.clearCounter(),this.countDownTimerId=setInterval(function(){return e<2?t.dismiss():(e--,void t.$emit("dismiss-count-down",e))},1e3)}}}},linkMixin={computed:{isRouterLink:function(){return Boolean(this.$router&&this.to&&!this.disabled)},_href:function(){return this.disabled?"#":this.href?this.href:this.to&&"string"==typeof this.to?this.to:void 0},computedRel:function(){return"_blank"===this.target&&null===this.rel?"noopener":this.rel||null},linkClassObject:function(){return[this.active?this.exact?this.exactActiveClass:this.activeClass:null,this.disabled?"disabled":null]}},props:{active:{type:Boolean,default:!1},disabled:Boolean,href:{type:String,default:"#"},target:{type:String,default:"_self"},rel:{type:String,default:null},to:{type:[String,Object],default:null},tag:{type:String,default:"a"},exact:Boolean,append:Boolean,replace:Boolean,activeClass:{type:String,default:"active"},exactActiveClass:{type:String,default:"active"},event:{type:[String,Array],default:"click"}},methods:{linkClick:function(t){this.disabled||(this.$root.$emit("clicked::link",this),this.$emit("click")),(this.disabled||!this.isRouterLink&&"#"===this._href)&&(t.preventDefault(),t.stopPropagation())}}},bLink={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return t.isRouterLink?n("router-link",{tag:"a",class:t.linkClassObject,attrs:{"active-class":t.activeClass,"exact-active-class":t.exactActiveClass,disabled:t.disabled,"aria-disabled":t.disabled?"true":"false",to:t.to,exact:t.exact,append:t.append,replace:t.replace,event:t.event,tag:t.tag},on:{click:t.linkClick}},[t._t("default")],2):n("a",{class:t.linkClassObject,attrs:{disabled:t.disabled,"aria-disabled":t.disabled?"true":"false",href:t._href,target:t.target||null,rel:t.computedRel},on:{click:t.linkClick}},[t._t("default")],2)},staticRenderFns:[],mixins:[linkMixin]},breadcrumb={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("ol",{staticClass:"breadcrumb",attrs:{role:"navigation"}},[t._l(t.items2,function(e){return n("li",{class:["breadcrumb-item",e.__active?"active":null],attrs:{role:"presentation"},on:{click:function(n){t.onclick(e)}}},[e.active?n("span",{domProps:{innerHTML:t._s(e.text)}}):n("b-link",{attrs:{to:e.to,href:e.href||e.link},domProps:{innerHTML:t._s(e.text)},on:{click:t.onclick}})],1)}),t._t("default")],2)},staticRenderFns:[],components:{bLink:bLink},computed:{componentType:function(){return this.to?"router-link":"a"},items2:function(){var t=this.items.length>0&&this.items[this.items.length-1];return this.items.map(function(e){return"string"==typeof e?{text:e,link:"#",active:e===t}:(e.active!==!0&&e.active!==!1?e.__active=e===t:e.__active=e.active,e)})}},props:{items:{type:Array,default:function(){return[]},required:!0}},methods:{onclick:function(t){this.$emit("click",t)}}},bBtn={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n(t.componentType,{tag:"button",class:t.classObject,attrs:{to:t.to,href:t.href,rel:t.rel,target:t.target,disabled:t.disabled},on:{click:t.onclick}},[t._t("default")],2)},staticRenderFns:[],components:{bLink:bLink},computed:{classObject:function(){return["btn",this.btnVariant,this.btnSize,this.btnBlock,this.btnDisabled,this.inactive?"btn-inactive":""]},componentType:function(){return this.href||this.to?"b-link":"button"},btnBlock:function(){return this.block?"btn-block":""},btnVariant:function(){return this.variant?"btn-"+this.variant:"btn-secondary"},btnSize:function(){return this.size?"btn-"+this.size:""},btnDisabled:function(){return this.disabled?"disabled":""}},props:{block:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},inactive:{type:Boolean,default:!1},size:{type:String,default:null},variant:{type:String,default:null},to:{type:[String,Object]},href:{type:String},target:{type:String},rel:{type:String}},methods:{onclick:function(t){this.disabled?(t.stopPropagation(),t.preventDefault()):this.$emit("click",t)}}},ITEM_SELECTOR=['.btn:not(.disabled):not([disabled]):not([style*="display: none"]):not([style*="display:none"])','.form-control:not(.disabled):not([disabled]):not([style*="display: none"]):not([style*="display:none"])','select:not(.disabled):not([disabled]):not([style*="display: none"]):not([style*="display:none"])','input[type="checkbox"]:not(.disabled):not([disabled]):not([style*="display: none"]):not([style*="display:none"])','input[type="radio"]:not(.disabled):not([disabled]):not([style*="display: none"]):not([style*="display:none"])'].join(","),buttonToolbar={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:t.classObject,attrs:{role:"toolbar",tabindex:t.keyNav?"0":null},on:{focusin:function(e){return e.target!==e.currentTarget?null:void t.focusFirst(e)},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"left",37)?"button"in e&&0!==e.button?null:void t.focusNext(e,!0):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38)?void t.focusNext(e,!0):null},function(e){return"button"in e||!t._k(e.keyCode,"right",39)?"button"in e&&2!==e.button?null:void t.focusNext(e,!1):null},function(e){return"button"in e||!t._k(e.keyCode,"down",40)?void t.focusNext(e,!1):null},function(e){return("button"in e||!t._k(e.keyCode,"left",37))&&e.shiftKey?"button"in e&&0!==e.button?null:void t.focusFirst(e):null},function(e){return("button"in e||!t._k(e.keyCode,"up",38))&&e.shiftKey?void t.focusFirst(e):null},function(e){return("button"in e||!t._k(e.keyCode,"right",39))&&e.shiftKey?"button"in e&&2!==e.button?null:void t.focusLast(e):null},function(e){return("button"in e||!t._k(e.keyCode,"down",40))&&e.shiftKey?void t.focusLast(e):null}]}},[t._t("default")],2)},staticRenderFns:[],computed:{classObject:function(){return["btn-toolbar",this.justify&&!this.vertical?"justify-content-between":""]}},props:{justify:{type:Boolean,default:!1},KeyNav:{type:Boolean,default:!1}},methods:{setItemFocus:function(t){this.$nextTick(function(){t.focus()})},focusNext:function(t,e){if(this.keyNav){t.preventDefault(),t.stopPropagation();var n=this.getItems();if(!(n.length<1)){var i=n.indexOf(t.target);e&&i>0?i--:!e&&i<n.length-1&&i++,i<0&&(i=0),this.setItemFocus(n[i])}}},focusFirst:function(t){if(this.keyNav){t.preventDefault(),t.stopPropagation();var e=this.getItems();e.length>0&&this.setItemFocus(e[0])}},focusLast:function(t){if(this.keyNav){t.preventDefault(),t.stopPropagation();var e=this.getItems();e.length>0&&this.setItemFocus([e.length-1])}},getItems:function(){var t=Array.prototype.slice.call(this.$el.querySelectorAll(ITEM_SELECTOR));return t.forEach(function(t){t.tabIndex=-1}),t}},mounted:function(){this.keyNav&&this.getItems()}},buttonGroup={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:t.classObject},[t._t("default")],2)},staticRenderFns:[],computed:{classObject:function(){return["btn-group",this.vertical?"btn-group-vertical":"",this.justify&&!this.vertical?"justify-content-between":"",this.size?"btn-group-"+this.size:""]}},props:{vertical:{type:Boolean,default:!1},justify:{type:Boolean,default:!1},size:{type:String,default:null}}},clickOut={mounted:function(){"undefined"!=typeof document&&document.documentElement.addEventListener("click",this._clickOutListener)},destroyed:function(){"undefined"!=typeof document&&document.removeEventListener("click",this._clickOutListener)},methods:{_clickOutListener:function(t){this.$el.contains(t.target)||this.clickOutListener&&this.clickOutListener()}}},ITEM_SELECTOR$1='.dropdown-item:not(.disabled):not([disabled]):not([style*="display: none"]):not([style*="display:none"])',HEADER_SELECTOR='.dropdown-header:not([style*="display: none"]):not([style*="display:none"])',ALL_SELECTOR=[ITEM_SELECTOR$1,HEADER_SELECTOR].join(","),dropdown={props:{split:{type:Boolean,default:!1},text:{type:String,default:""},dropup:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},right:{type:Boolean,default:!1}},created:function(){var t=this,e=function(e){e!==t&&(t.visible=!1)};this.$root.$on("shown::dropdown",e),this.$root.$on("clicked::link",e)},watch:{visible:function(t,e){var n=this;if(t!==e)if(t){if(this.$root.$emit("shown::dropdown",this),"undefined"!=typeof document&&"ontouchstart"in document.documentElement){var i=Array.prototype.slice.call(document.body.children);i.forEach(function(t){t.addEventListener("mouseover",n.noop)})}}else if(this.$root.$emit("hidden::dropdown",this),"undefined"!=typeof document&&"ontouchstart"in document.documentElement){var s=Array.prototype.slice.call(document.body.children);s.forEach(function(t){t.removeEventListener("mouseover",n.noop)})}}},methods:{noop:function(){},toggle:function(){return this.disabled?void(this.visible=!1):(this.visible=!this.visible,void(this.visible&&this.$nextTick(function(){var t=this.getFirstItem();t&&this.focusItem(0,[t])})))},onTab:function(){this.visible&&(this.visible=!1)},onEsc:function(t){this.visible&&(this.visible=!1,t.preventDefault(),t.stopPropagation(),this.$nextTick(function(){var t;t=this.split&&this.$refs.toggle?this.$refs.toggle.$el||this.$refs.toggle:this.$refs.button.$el||this.$refs.button,t&&t.focus&&t.focus()}))},focusNext:function(t,e){if(this.visible){t.preventDefault(),t.stopPropagation();var n=this.getItems();if(!(n.length<1)){var i=n.indexOf(t.target);e&&i>0?i--:!e&&i<n.length-1&&i++,i<0&&(i=0),this.focusItem(i,n)}}},focusHovered:function(t){if(this.visible){var e=this.getItems();if(!(e.length<1)){var n=e.indexOf(t.target);n>-1&&(t.preventDefault(),t.stopPropagation(),this.focusItem(n,e))}}},focusItem:function(t,e){e.forEach(function(e,n){n===t?(e.classList.add("active"),e.focus()):e.classList.remove("active")})},getItems:function(){return Array.prototype.slice.call(this.$refs.menu.querySelectorAll(ALL_SELECTOR))},getFirstItem:function(){var t=this.$refs.menu.querySelector(ITEM_SELECTOR$1);return t||(t=this.$refs.menu.querySelector(HEADER_SELECTOR)),t||null}}},buttonGroupDropdown={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:["btn-group","dropdown",{dropup:t.dropup,show:t.visible}]},[n("b-button",{ref:"button",class:{"dropdown-toggle":!t.split,"btn-link":t.link},attrs:{id:t.id?t.id+"__BV_button_":null,"aria-expanded":t.visible?"true":"false",variant:t.variant,size:t.size,disabled:t.disabled},on:{click:function(e){e.stopPropagation(),e.preventDefault(),t.click(e)},kedown:[function(e){return"button"in e||!t._k(e.keyCode,"space",32)?(e.stopPropagation(),e.preventDefault(),void t.click(e)):null},function(e){return"button"in e||!t._k(e.keyCode,"enter",13)?(e.stopPropagation(),e.preventDefault(),void t.click(e)):null}]}},[t._t("text",[t._v(t._s(t.text))])],2),n("div",{ref:"menu",class:["dropdown-menu",{"dropdown-menu-right":t.right}],attrs:{role:"menu","aria-labelledby":t.id?t.id+"__BV_button_":null},on:{keyup:function(e){return"button"in e||!t._k(e.keyCode,"esc",27)?void t.onEsc(e):null},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"tab",9)?void t.onTab(e):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38)?void t.focusNext(e,!0):null},function(e){return"button"in e||!t._k(e.keyCode,"down",40)?void t.focusNext(e,!1):null}],mouseover:function(e){t.focusHovered(e)}}},[t._t("default")],2)],1)},staticRenderFns:[],mixins:[clickOut,dropdown],data:function(){return{visible:!1}},computed:{dropdownToggle:function(){return this.caret?"dropdown-toggle":""}},props:{id:{type:String},caret:{type:Boolean,default:!0}},methods:{clickOutListener:function(){this.visible=!1}}},inputGroup={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:t.classObject,attrs:{role:"group"}},[t._t("left",[t.left?n("div",{staticClass:"input-group-addon",domProps:{innerHTML:t._s(t.left)}}):t._e()]),t._t("default"),t._t("right",[t.right?n("div",{staticClass:"input-group-addon",domProps:{innerHTML:t._s(t.right)}}):t._e()])],2)},staticRenderFns:[],computed:{classObject:function(){return["input-group",this.size?"input-group-"+this.size:"",this.state?"has-"+this.state:""]}},props:{size:{type:String,default:null},state:{type:String,default:null},left:{type:String,default:null},right:{type:String,default:null}}},inputGroupAddon={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"input-group-addon",attrs:{id:t.id}},[t._t("default")],2)},staticRenderFns:[],props:{id:{type:String,default:null}}},inputGroupButton={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"input-group-btn"},[t._t("default")],2)},staticRenderFns:[],props:{}},card={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n(t.tag,{tag:"component",class:["card",t.cardVariant,t.cardAlign,t.cardInverse]},[t._t("img",[t.img?n("img",{staticClass:"card-img",attrs:{src:t.img,alt:t.imgAlt}}):t._e()]),t.header||t.showHeader?n(t.headerTag,{tag:"component",staticClass:"card-header"},[t._t("header",[n("div",{domProps:{innerHTML:t._s(t.header)}})])],2):t._e(),t.noBlock?[t._t("default")]:n("div",{class:t.blockClass},[t.title?n("h4",{staticClass:"card-title",domProps:{innerHTML:t._s(t.title)}}):t._e(),t.subTitle?n("h6",{staticClass:"card-subtitle mb-2 text-muted",domProps:{innerHTML:t._s(t.subTitle)}}):t._e(),t._t("default")],2),t.footer||t.showFooter?n(t.footerTag,{tag:"component",staticClass:"card-footer"},[t._t("footer",[n("div",{domProps:{innerHTML:t._s(t.footer)}})])],2):t._e()],2)},staticRenderFns:[],computed:{blockClass:function(){return["card-block",this.overlay?"card-img-overlay":null]},cardVariant:function(){return this.variant?"card-"+this.variant:null},cardInverse:function(){return this.overlay||this.inverse?"card-inverse":null===this.inverse&&this.variant&&this.variant.length>0&&this.variant.indexOf("outline")===-1?"card-inverse":void 0},cardAlign:function(){return this.align?"text-"+this.align:null}},props:{align:{type:String,default:null},inverse:{type:Boolean,default:null},variant:{type:String,default:null},tag:{type:String,default:"div"},header:{type:String,default:null},showHeader:{type:Boolean,default:!1},headerTag:{type:String,default:"div"},footer:{type:String,default:null},showFooter:{type:Boolean,default:!1},footerTag:{type:String,default:"div"},title:{type:String,default:null},subTitle:{type:String,default:null},noBlock:{type:Boolean,default:!1},img:{type:String,default:null},imgAlt:{type:String,default:null},overlay:{type:Boolean,default:!1}}},cardGroup={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n(t.tag,{tag:"component",class:["card-"+t.type]},[t._t("default")],2)},staticRenderFns:[],computed:{type:function(){return this.deck?"deck":this.columns?"columns":"group"}},props:{tag:{type:String,default:"div"},deck:{type:Boolean,default:!1},columns:{type:Boolean,default:!1}}},DIRECTION={next:{current:"carousel-item-left",next:"carousel-item-right",overlay:"carousel-item-next"},prev:{current:"carousel-item-right",next:"carousel-item-left",overlay:"carousel-item-prev"}},carousel={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"carousel slide",style:{background:t.background,height:t.height},attrs:{role:"region",id:t.id||null,"aria-busy":t.isSliding?"true":"false"},on:{mouseenter:t.pause,mouseleave:t.start,focusin:t.pause,focusout:function(e){t.restart(e)},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"left",37)?"button"in e&&0!==e.button?null:(e.stopPropagation(),e.preventDefault(),void t.prev(e)):null},function(e){return"button"in e||!t._k(e.keyCode,"right",39)?"button"in e&&2!==e.button?null:(e.stopPropagation(),e.preventDefault(),void t.next(e)):null}]}},[n("div",{staticClass:"carousel-inner",attrs:{role:"list",id:t.id?t.id+"__BV_inner_":null}},[t._t("default")],2),t.controls?[n("a",{staticClass:"carousel-control-prev",attrs:{href:"#",role:"button","aria-controls":t.id?t.id+"__BV_inner_":null},on:{click:function(e){e.stopPropagation(),e.preventDefault(),t.prev(e)},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"enter",13)?(e.stopPropagation(),e.preventDefault(),void t.prev(e)):null},function(e){return"button"in e||!t._k(e.keyCode,"space",32)?(e.stopPropagation(),e.preventDefault(),void t.prev(e)):null}]}},[n("span",{staticClass:"carousel-control-prev-icon",attrs:{"aria-hidden":"true"}}),t._v(" "),n("span",{staticClass:"sr-only"},[t._v(t._s(t.labelPrev))])]),n("a",{staticClass:"carousel-control-next",attrs:{href:"#",role:"button","aria-controls":t.id?t.id+"__BV_inner_":null},on:{click:function(e){e.stopPropagation(),e.preventDefault(),t.next(e)},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"enter",13)?(e.stopPropagation(),e.preventDefault(),void t.next(e)):null},function(e){return"button"in e||!t._k(e.keyCode,"space",32)?(e.stopPropagation(),e.preventDefault(),void t.next(e)):null}]}},[n("span",{staticClass:"carousel-control-next-icon",attrs:{"aria-hidden":"true"}}),t._v(" "),n("span",{staticClass:"sr-only"},[t._v(t._s(t.labelNext))])])]:t._e(),n("ol",{directives:[{name:"show",rawName:"v-show",value:t.indicators,expression:"indicators"}],staticClass:"carousel-indicators",attrs:{role:"group",id:t.id?t.id+"__BV_indicators_":null,"aria-hidden":t.indicators?"false":"true","aria-label":t.indicators&&t.labelIndicators?t.labelIndicators:null,"aria-owns":t.indicators&&t.id?t.id+"__BV_inner_":null}},t._l(t.slides.length,function(e){return n("li",{class:{active:e-1===t.index},attrs:{role:"button",id:t.id?t.id+"__BV_indicator_"+e+"_":null,tabindex:t.indicators?"0":"-1","aria-current":e-1===t.index?"true":"false","aria-posinset":e,"aria-setsize":t.slides.length,"aria-label":t.labelGotoSlide+" "+e,"aria-describedby":t.slides[e-1].id||null,"aria-controls":t.id?t.id+"__BV_inner_":null},on:{click:function(n){t.index=e-1},keydown:[function(n){return"button"in n||!t._k(n.keyCode,"enter",13)?(n.stopPropagation(),n.preventDefault(),void(t.index=e-1)):null},function(n){return"button"in n||!t._k(n.keyCode,"space",32)?(n.stopPropagation(),n.preventDefault(),void(t.index=e-1)):null}]}})}))],2)},staticRenderFns:[],data:function(){return{index:0,isSliding:!1,slides:[]}},props:{id:{type:String},labelPrev:{type:String,default:"Previous Slide"},labelNext:{type:String,default:"Next Slide"},labelGotoSlide:{type:String,default:"Goto Slide"},labelIndicators:{type:String,default:"Select a slide to display"},interval:{type:Number,default:5e3},indicators:{type:Boolean,default:!1},controls:{type:Boolean,default:!1},height:{type:String},background:{type:String}},methods:{prev:function(){this.index<=0?this.index=this.slides.length-1:this.index--},next:function(){"undefined"!=typeof document&&document.visibilityState&&document.hidden||(this.index>=this.slides.length-1?this.index=0:this.index++)},pause:function(){0!==this.interval&&"undefined"!=typeof this.interval&&(clearInterval(this._intervalId),this._intervalId=null,this.slides[this.index].tabIndex=0)},start:function(){var t=this;0!==this.interval&&"undefined"!=typeof this.interval&&(this.slides.forEach(function(t){t.tabIndex=-1}),this._intervalId=setInterval(function(){t.next()},this.interval))},restart:function(t){t.relatedTarget&&this.$el.contains(t.relatedTarget)||this.start()}},mounted:function(){this.slides=Array.prototype.slice.call(this.$el.querySelectorAll(".carousel-item")),this.slides[0].classList.add("active");var t=this;this.slides.forEach(function(e,n){var i=n+1;e.setAttribute("aria-current",0===n?"true":"false"),e.setAttribute("aria-posinset",String(i)),e.setAttribute("aria-setsize",String(t.slides.length)),e.tabIndex=-1,t.id&&e.setAttribute("aria-controlledby",t.id+"__BV_indicator_"+i+"_")}),this._intervalId=null,this.start()},watch:{index:function(t,e){var n=this;if(t!==e){if(this.isSliding)return void(this.index=e);var i=t>e?DIRECTION.next:DIRECTION.prev;0===e&&t===this.slides.length-1?i=DIRECTION.prev:e===this.slides.length-1&&0===t&&(i=DIRECTION.next);var s=this.slides[e],o=this.slides[t];s&&o&&(this.isSliding=!0,o.classList.add(i.next,i.overlay),s.classList.add(i.current),this._carouselAnimation=setTimeout(function(){n.$emit("slide",t),s.classList.remove("active"),s.setAttribute("aria-current","false"),s.setAttribute("aria-hidden","true"),s.tabIndex=-1,s.classList.remove(i.current),o.classList.add("active"),o.setAttribute("aria-current","true"),o.setAttribute("aria-hidden","false"),o.tabIndex=-1,o.classList.remove(i.next,i.overlay),n._intervalId||(s.tabIndex=0,n.$nextTick(function(){s.focus()})),n.isSliding=!1},500))}}},destroyed:function(){clearTimeout(this._carouselAnimation),clearInterval(this._intervalId)}},carouselSlide={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"carousel-item",style:{background:t.background,height:t.height},attrs:{role:"listitem",id:t.id||null}},[t.img?n("img",{staticClass:"d-block img-fluid",attrs:{src:t.img,alt:t.imgAlt}}):t._e(),n("div",{class:t.contentClasses},[t.caption?n("h3",{domProps:{innerHTML:t._s(t.caption)}}):t._e(),t.text?n("p",{domProps:{innerHTML:t._s(t.text)}}):t._e(),t._t("default")],2)])},staticRenderFns:[],props:{id:{type:String},img:{type:String},imgAlt:{type:String},contentVisibleUp:{type:String},caption:{type:String},text:{type:String},background:{type:String},height:{type:String}},computed:{contentClasses:function(){var t={"carousel-caption":Boolean(this.caption)};return this.contentVisibleUp&&(t["d-none"]=!0,t["d-"+this.contentVisibleUp+"-block"]=!0),t}}},collapse={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("transition",{attrs:{name:"collapse"},on:{enter:t.enter,"after-enter":t.clearHeight,leave:t.leave,"after-leave":t.clearHeight}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.show,expression:"show"}],class:t.classObject,attrs:{id:t.id||null}},[t._t("default")],2)])},staticRenderFns:[],_scopeId:"data-v-67b0a2de",data:function(){return{show:!1}},computed:{classObject:function(){return{"navbar-collapse":this.isNav,show:this.show}}},props:{isNav:{type:Boolean,default:!1},id:{type:String,required:!0}},methods:{toggle:function(){this.show=!this.show,this.emitState()},enter:function(t){t.style.height="auto";var e=getComputedStyle(t).height;t.style.height="0px",t.offsetHeight,t.style.height=e},leave:function(t){t.style.height="auto";var e=getComputedStyle(t).height;t.style.height=e,t.offsetHeight,t.style.height="0px"},clearHeight:function(t){t.style.height=null},emitState:function(){this.$root.$emit("collapse::toggle::state",this.id,this.show)}},created:function(){var t=this;this.$root.$on("collapse::toggle",function(e){e===t.id&&t.toggle()})},mounted:function(){this.emitState()}},dropdown$1={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:["dropdown","btn-group",{dropup:t.dropup,show:t.visible}],attrs:{id:t.id||null}},[n("a",[n("b-button",{ref:"button",class:{"dropdown-toggle":!t.split,"btn-link":t.link},attrs:{id:t.id?t.id+"__BV_button_":null,"aria-haspopup":t.split?null:"true","aria-expanded":t.split?null:t.visible?"true":"false",variant:"link",size:t.size,disabled:t.disabled},on:{click:function(e){e.stopPropagation(),e.preventDefault(),t.click(e)}}},[t._t("text",[t._v(t._s(t.text))])],2)],1),t.split?n("b-button",{ref:"toggle",class:["dropdown-toggle","dropdown-toggle-split",{"btn-link":t.link}],attrs:{id:t.id?t.id+"__BV_toggle_":null,"aria-haspopup":t.split?"true":null,"aria-expanded":t.split?t.visible?"true":"false":null,variant:t.variant,size:t.size,disabled:t.disabled},on:{click:function(e){e.stopPropagation(),e.preventDefault(),t.toggle(e)}}},[n("span",{staticClass:"sr-only"},[t._v(t._s(t.toggleText))])]):t._e(),n("div",{ref:"menu",class:["dropdown-menu",{"dropdown-menu-right":t.right}],attrs:{role:"menu","aria-labelledby":t.id?t.id+(t.split?"__BV_toggle_":"__BV_button_"):null},on:{keyup:function(e){return"button"in e||!t._k(e.keyCode,"esc",27)?void t.onEsc(e):null},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"tab",9)?void t.onTab(e):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38)?void t.focusNext(e,!0):null},function(e){return"button"in e||!t._k(e.keyCode,"down",40)?void t.focusNext(e,!1):null}],mouseover:function(e){t.focusHovered(e)}}},[t._t("default")],2)],1)},staticRenderFns:[],mixins:[clickOut,dropdown],components:{bButton:bBtn},data:function(){return{visible:!1}},props:{id:{type:String},toggleText:{type:String,default:"Toggle Dropdown"},size:{type:String,default:null},variant:{type:String,default:null},link:{type:Boolean,default:!1}},methods:{clickOutListener:function(){this.visible=!1},click:function(t){return this.disabled?void(this.visible=!1):(console.log(this),void(this.split?(this.$emit("click",t),this.$root.$emit("shown::dropdown",this)):(console.log("C'est toggle !"),this.toggle())))}}},dropdownItem={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("b-link",{staticClass:"dropdown-item",attrs:{role:"menuitem",active:t.active,disabled:t.disabled,href:t.href,to:t.to,tag:t.tag,exact:t.exact,append:t.append,replace:t.replace,"active-class":t.activeClass,"exact-active-class":t.exactActiveClass,event:t.event,target:t.target,rel:t.rel},on:{click:function(e){t.$emit("click")}}},[t._t("default")],2)},staticRenderFns:[],components:{bLink:bLink},mixins:[linkMixin]},dropdownDivider={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"dropdown-divider",attrs:{role:"separator"}})},staticRenderFns:[],props:{}},dropdownHeader={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n(t.tag,{tag:"component",staticClass:"dropdown-header",attrs:{tabindex:"-1"}},[t._t("default")],2)},staticRenderFns:[],props:{tag:{type:String,default:"h6"}}},dropdownSelect={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"dropdown-select",class:{open:t.show,dropdown:!t.dropup,dropup:t.dropup}},[n("button",{class:["btn","dropdown",t.dropdownToggle,t.btnVariant,t.btnSize],attrs:{id:t.id,role:"button","aria-haspopup":"true","aria-expanded":"show",disabled:t.disabled},on:{click:function(e){e.preventDefault(),t.toggle(e)}}},[n("span",{staticClass:"checked-items",domProps:{innerHTML:t._s(t.displayItem)}})]),n("ul",{staticClass:"dropdown-menu",class:{"dropdown-menu-right":"right"==t.position},attrs:{"aria-labelledby":"dLabel"}},t._l(t.list,function(e){return n("li",[n("button",{staticClass:"dropdown-item",attrs:{click:t.select(e)}},[t._v(t._s(e.text))])])}))])},staticRenderFns:[],data:function(){return{show:!1,selected:!1}},computed:{btnVariant:function(){return this.variant&&"default"!==this.variant?"btn-"+this.variant:"btn-secondary"},btnSize:function(){return this.size&&"default"!==this.size?"btn-"+this.size:""},dropdownToggle:function(){return this.caret?"dropdown-toggle":""},displayItem:function(){if(this.returnObject&&this.model&&!this.model.text||!this.returnObject&&this.model&&0===this.model.length||this.forceDefault)return this.defaultText;if(this.returnObject&&this.model&&this.model.text)return this.model.text;if(!this.returnObject&&this.model){var t=this.model||"";return this.list.forEach(function(e){e.value===this.model&&(t=e.text)}),t}return""}},props:{id:{type:String},model:{required:!1},list:{type:Array,default:[],required:!0},caret:{type:Boolean,default:!0},position:{type:String,default:"left"},size:{type:String,default:""},variant:{type:String,default:"default"},defaultText:{type:String,default:"Plase select one"},forceDefault:{type:Boolean,default:!1},returnObject:{type:Boolean,default:!1},dropup:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1}},methods:{toggle:function(t){this.show=!this.show,this.show?(this.$root.$emit("shown:dropdown",this.id),t.stopPropagation()):this.$root.$emit("hidden::dropdown",this.id)},select:function(t){this.returnObject?this.model=t:this.model=t.value,this.show=!1,this.$root.$emit("selected::dropdown",this.id,this.model)}},created:function(){var t=this.$root;t.$on("hide::dropdown",function(){this.show=!1})}},form={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("form",{class:t.classObject},[t._t("default")],2)},staticRenderFns:[],computed:{classObject:function(){return[this.inline?"form-inline":""]}},props:{inline:{type:Boolean,default:!1}}},formFieldset={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:["form-group","row",t.inputState],attrs:{role:"group","aria-describedby":t.describedBy}},[t.label?n("label",{class:[t.labelSrOnly?"sr-only":"col-form-label",t.labelLayout,t.labelAlignClass],attrs:{for:t.target,id:t.labelId},domProps:{innerHTML:t._s(t.label)}}):t._e(),n("div",{ref:"content",class:t.inputLayout},[t._t("default"),t.feedback?n("div",{staticClass:"form-text form-control-feedback",attrs:{id:t.feedbackId,role:"alert","aria-live":"assertive","aria-atomic":"true"},domProps:{
innerHTML:t._s(t.feedback)}}):t._e(),t.description?n("small",{staticClass:"form-text text-muted",attrs:{id:t.descriptionId},domProps:{innerHTML:t._s(t.description)}}):t._e()],2)])},staticRenderFns:[],data:function(){return{target:null}},computed:{labelId:function(){return this.id&&this.label?this.id+"__BV_label_":null},descriptionId:function(){return this.id&&this.description?this.id+"__BV_description_":null},feedbackId:function(){return this.id&&this.feedback?this.id+"__BV_feedback_":null},describedBy:function(){return this.id&&(this.label||this.feedback||this.description)?[this.labelId,this.descriptionId,this.feedbackId].filter(function(t){return t}).join(" "):null},inputState:function(){return this.state?"has-"+this.state:""},labelLayout:function(){return this.labelSrOnly?null:this.horizontal?"col-sm-"+this.labelSize:"col-12"},labelAlignClass:function(){return this.labelSrOnly?null:this.labelTextAlign?"text-"+this.labelTextAlign:null},inputLayout:function(){return this.horizontal?"col-sm-"+(12-this.labelSize):"col-12"}},methods:{updateTarget:function(){var t=this.$refs.content;if(!t)return null;var e=t.querySelector(this.inputSelector);this.target=e&&e.id?e.id:null}},mounted:function(){this.updateTarget()},updated:function(){this.updateTarget()},props:{id:{type:String,default:null},state:{type:String,default:null},horizontal:{type:Boolean,default:!1},labelSize:{type:Number,default:3},labelTextAlign:{type:String,default:null},label:{type:String,default:null},labelSrOnly:{type:Boolean,default:!1},description:{type:String,default:null},feedback:{type:String,default:null},inputSelector:{type:String,default:"input,select,textarea,.form-control,.form-control-static,.dropdown,.dropup"}}},formMixin={computed:{inputClass:function(){return[this.size?"form-control-"+this.size:null,this.state?"form-control-"+this.state:null]},custom:function(){return!this.plain}},props:{name:{type:String},disabled:{type:Boolean},plain:{type:Boolean,default:!1},state:{type:String},size:{type:String},id:{type:String}}},formCheckBoxMixin={computed:{checkboxClass:function(){return{"custom-control":this.custom,"form-check-inline":this.inline}}}},inBrowser="undefined"!=typeof window,UNSAFE_UID=inBrowser&&window.UNSAFE_UID===!0||!inBrowser&&__webpack_require__.i({"NODE_ENV":"production"}).UNSAFE_UID===!0,generateId={computed:{_id:function(){return!UNSAFE_UID||this.id?this.id:"__b_"+this._uid+"__"}}},formCheckbox={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("label",{class:[t.inputClass,t.checkboxClass,t.custom?"custom-checkbox":null]},[n("input",{class:[t.custom?"custom-control-input":null],attrs:{type:"checkbox",id:t._id,name:t.name,disabled:t.disabled},domProps:{value:t.value,checked:t.isChecked},on:{change:t.handleChange}}),t._v(" "),t.custom?n("span",{staticClass:"custom-control-indicator"}):t._e(),t._v(" "),n("span",{class:[t.custom?"custom-control-description":null]},[t._t("default")],2)])},staticRenderFns:[],mixins:[formMixin,formCheckBoxMixin,generateId],model:{prop:"checked",event:"change"},props:{value:{default:!0},uncheckedValue:{default:!1},checked:{default:!0}},computed:{isChecked:function(){return this.checked.includes(this.value)}},methods:{handleChange:function(t){var e=this,n=t.target.checked;Array.isArray(this.checked)?this.isChecked?this.$emit("change",this.checked.filter(function(t){return t!==e.value})):this.$emit("change",this.checked.concat([this.value])):this.$emit("change",n?this.value:this.uncheckedValue)}}},formOptions={computed:{formOptions:function(){var t=this,e=this.options||{};return e=Array.isArray(e)?e.map(function(e){return"object"==typeof e?{value:e[t.valueField],text:e[t.textField],disabled:e.disabled||!1}:{text:String(e),value:e||{}}}):Object.keys(e).map(function(n){var i=e[n]||{};return"object"!=typeof i&&(i={text:String(i)}),i.value=i[t.valueField]||n,i})},selectedValue:function(){for(var t=this,e=this.formOptions,n=0;n<e.length;n++)if(e[n].value===t.localValue)return t.returnObject?e[n]:e[n].value}},props:{valueField:{type:[String],default:"value"},textField:{type:[String],default:"text"}},watch:{localValue:function(t,e){t!==e&&this.$emit("input",this.selectedValue)},value:function(t,e){t!==e&&(this.localValue=t)}}},formRadio={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:[t.inputClass,this.stacked?"custom-controls-stacked":""]},t._l(t.formOptions,function(e){return n("label",{class:[t.checkboxClass,t.custom?"custom-radio":null]},[n("input",{directives:[{name:"model",rawName:"v-model",value:t.localValue,expression:"localValue"}],ref:"inputs",refInFor:!0,class:t.custom?"custom-control-input":null,attrs:{type:"radio",name:e.name,id:e.id,disabled:e.disabled},domProps:{value:e.value,checked:t._q(t.localValue,e.value)},on:{__c:function(n){t.localValue=e.value}}}),t._v(" "),t.custom?n("span",{staticClass:"custom-control-indicator"}):t._e(),t._v(" "),n("span",{class:t.custom?"custom-control-description":null,domProps:{innerHTML:t._s(e.text)}})])}))},staticRenderFns:[],mixins:[formMixin,formCheckBoxMixin,formOptions],data:function(){return{localValue:this.value}},computed:{inputState:function(){return this.state?"has-"+this.state:""}},props:{value:{},options:{type:[Array,Object],default:null,required:!0},stacked:{type:Boolean,default:!1},returnObject:{type:Boolean,default:!1}}},bFormInputStatic={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("p",{class:["form-control-static",t.inputClass],attrs:{id:t._id},domProps:{innerHTML:t._s(t.staticValue)}},[t._t("default")],2)},staticRenderFns:[],mixins:[formMixin,generateId],computed:{staticValue:function(){return this.formatter?this.formatter(this.value):this.value}},props:{value:{default:null},formatter:{type:Function}}},formInput={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return t.static?n("b-form-input-static",{attrs:{id:t._id,value:t.value,formatter:t.formatter}}):n(t.textarea?"textarea":"input",{ref:"input",tag:"input",class:["form-control",t.inputClass],attrs:{type:t.type,name:t.name,id:t._id,disabled:t.disabled,rows:t.rows||t.rowsCount,placeholder:t.placeholder},domProps:{value:t.value},on:{input:function(e){t.onInput(e.target.value)},change:function(e){t.onChange(e.target.value)},keyup:function(e){t.onKeyUp(e)},focus:function(e){t.$emit("focus")},blur:function(e){t.$emit("blur")}}})},staticRenderFns:[],mixins:[formMixin,generateId],components:{bFormInputStatic:bFormInputStatic},computed:{rowsCount:function(){return(this.value||"").toString().split("\n").length}},methods:{format:function(t){if(this.formatter){var e=this.formatter(t);e!==t&&(t=e,this.$refs.input.value=e)}return t},onInput:function(t){this.lazyFormatter||(t=this.format(t)),this.$emit("input",t)},onChange:function(t){t=this.format(t),this.$emit("input",t),this.$emit("change",t)},onKeyUp:function(t){this.$emit("keyup",t)},focus:function(){this.$refs.input.focus()}},props:{value:{default:null},type:{type:String,default:"text"},static:{type:Boolean,default:!1},placeholder:{type:String,default:null},rows:{type:Number,default:null},textarea:{type:Boolean,default:!1},formatter:{type:Function},lazyFormatter:{type:Boolean,default:!1}}},formFile={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("label",{class:[t.custom?"custom-file":null,t.inputClass],on:{dragover:function(e){e.stopPropagation(),e.preventDefault(),t.dragover(e)}}},[t.dragging?n("span",{staticClass:"drop-here",attrs:{"data-drop":t.dropLabel},on:{dragover:function(e){e.stopPropagation(),e.preventDefault(),t.dragover(e)},drop:function(e){e.stopPropagation(),e.preventDefault(),t.drop(e)},dragleave:function(e){e.stopPropagation(),e.preventDefault(),t.dragging=!1}}}):t._e(),n("input",{ref:"input",staticClass:"custom-file-input",attrs:{type:"file",name:t.name,id:t._id,disabled:t.disabled,accept:t.accept,multiple:t.multiple,webkitdirectory:t.directory},on:{change:t.onFileChange}}),t._v(" "),t.custom?n("span",{class:["custom-file-control",t.dragging?"dragging":null,t.inputClass],attrs:{"data-choose":t.computedChooseLabel,"data-selected":t.selectedLabel}}):t._e()])},staticRenderFns:[],mixins:[formMixin,generateId],data:function(){return{selectedFile:null,dragging:!1}},computed:{selectedLabel:function(){return this.selectedFile&&0!==this.selectedFile.length?this.multiple?1===this.selectedFile.length?this.selectedFile[0].name:this.selectedFormat.replace(":names",this.selectedFile.map(function(t){return t.name}).join(",")).replace(":count",this.selectedFile.length):this.selectedFile.name:this.placeholder||"No file chosen"},computedChooseLabel:function(){return this.chooseLabel||(this.multiple?"Choose Files":"Choose File")}},watch:{selectedFile:function(t,e){t!==e&&(!t&&this.multiple?this.$emit("input",[]):this.$emit("input",t))}},methods:{onFileChange:function(t){var e=this;this.$emit("change",t);var n=t.dataTransfer&&t.dataTransfer.items;if(n&&!this.noTraverse){for(var i=[],s=0;s<n.length;s++){var o=n[s].webkitGetAsEntry();o&&i.push(e.traverseFileTree(o))}return void Promise.all(i).then(function(t){e.setFiles(Array.prototype.concat.apply([],t))})}this.setFiles(t.target.files||t.dataTransfer.files)},setFiles:function(t){var e=this;if(!t)return void(this.selectedFile=null);if(!this.multiple)return void(this.selectedFile=t[0]);for(var n=[],i=0;i<t.length;i++)t[i].type.match(e.accept)&&n.push(t[i]);this.selectedFile=n},dragover:function(t){this.noDrop||(this.dragging=!0,t.dataTransfer.dropEffect="copy")},drop:function(t){this.noDrop||(this.dragging=!1,t.dataTransfer.files&&t.dataTransfer.files.length>0&&this.onFileChange(t))},traverseFileTree:function(t,e){var n=this;return new Promise(function(i){e=e||"",t.isFile?t.file(function(t){t.$path=e,i(t)}):t.isDirectory&&t.createReader().readEntries(function(s){for(var o=[],r=0;r<s.length;r++)o.push(n.traverseFileTree(s[r],e+t.name+"/"));Promise.all(o).then(function(t){i(Array.prototype.concat.apply([],t))})})})}},props:{accept:{type:String,default:""},placeholder:{type:String,default:null},chooseLabel:{type:String,default:null},multiple:{type:Boolean,default:!1},directory:{type:Boolean,default:!1},noTraverse:{type:Boolean,default:!1},selectedFormat:{type:String,default:":count Files"},noDrop:{type:Boolean,default:!1},dropLabel:{type:String,default:"Drop files here"}}},formSelect={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("select",{directives:[{name:"model",rawName:"v-model",value:t.localValue,expression:"localValue"}],ref:"input",class:[t.inputClass,t.custom?"custom-select":null],attrs:{name:t.name,id:t._id,disabled:t.disabled},on:{change:function(e){var n=Array.prototype.filter.call(e.target.options,function(t){return t.selected}).map(function(t){var e="_value"in t?t._value:t.value;return e});t.localValue=e.target.multiple?n:n[0]}}},t._l(t.formOptions,function(e){return n("option",{attrs:{disabled:e.disabled},domProps:{value:e.value,innerHTML:t._s(e.text)}})}))},staticRenderFns:[],mixins:[formMixin,formOptions,generateId],data:function(){return{localValue:this.value}},props:{value:{},options:{type:[Array,Object],required:!0},returnObject:{type:Boolean,default:!1}}},jumbotron={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:["jumbotron",t.fluid?"jumbotron-fluid":null]},[n("div",{class:t.containerFluid?"container-fluid":"container"},[t.header?n("h1",{staticClass:"display-3",domProps:{innerHTML:t._s(t.header)}}):t._e(),t.lead?n("p",{staticClass:"lead",domProps:{innerHTML:t._s(t.lead)}}):t._e(),t._t("default")],2)])},staticRenderFns:[],computed:{},props:{fluid:{type:Boolean,default:!1},containerFluid:{type:Boolean,default:!1},header:{type:String,default:null},lead:{type:String,default:null}}},badge={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("span",{class:["badge",t.badgeVariant,t.badgePill]},[t._t("default")],2)},staticRenderFns:[],computed:{badgeVariant:function(){return this.variant&&"default"!==this.variant?"badge-"+this.variant:"badge-default"},badgePill:function(){return this.pill?"badge-pill":""}},props:{variant:{type:String,default:"default"},pill:{type:Boolean,default:!1}}},listGroup={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n(t.tag,{tag:"component",class:["list-group",t.flush?"list-group-flush":null]},[t._t("default")],2)},staticRenderFns:[],props:{tag:{type:String,default:"div"},flush:{type:Boolean,default:!1}}},actionTags=["a","router-link","button","b-link"],listGroupItem={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n(t.myTag,{ref:"item",tag:"component",class:t.classObject,attrs:{to:t.to,href:t.href,target:t.target,rel:t.rel}},[t._t("default")],2)},staticRenderFns:[],components:{bLink:bLink},computed:{classObject:function(){return["list-group-item",this.listState,this.active?"active":null,this.disabled?"disabled":null,this.isAction?"list-group-item-action":null]},isAction:function(){return this.action!==!1&&(this.action||this.to||this.href||actionTags.indexOf(this.tag)!==-1)},listState:function(){return this.variant?"list-group-item-"+this.variant:null},myTag:function(){return this.tag?this.tag:this.to||this.href?"b-link":"div"}},props:{tag:{type:String,default:null},active:{type:Boolean,default:!1},action:{type:Boolean,default:null},disabled:{type:Boolean,default:!1},variant:{type:String,default:null},to:{type:String,default:null},href:{type:String,default:null},target:{type:String,default:null},rel:{type:String,default:null}}},media={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"media"},[t.rightAlign?t._e():n("div",{class:["d-flex","mr-3",t.verticalAlignClass]},[t._t("aside")],2),n("div",{staticClass:"media-body"},[t._t("default")],2),t.rightAlign?n("div",{class:["d-flex","ml-3",t.verticalAlignClass]},[t._t("aside")],2):t._e()])},staticRenderFns:[],computed:{verticalAlignClass:function(){return"align-self-"+this.verticalAlign}},props:{rightAlign:{type:Boolean,default:!1},verticalAlign:{type:String,default:"top"}}},FOCUS_SELECTOR=['button:not([disabled]):not([style*="display: none"]):not([style*="display:none"])','input:not([disabled]):not([style*="display: none"]):not([style*="display:none"])','select:not([disabled]):not([style*="display: none"]):not([style*="display:none"])','textarea:not([disabled]):not([style*="display: none"]):not([style*="display:none"])','a:not([disabled]):not(.disabled):not([style*="display: none"]):not([style*="display:none"])','[tabindex]:not([disabled]):not(.disabled):not([style*="display: none"]):not([style*="display:none"])'].join(","),modal={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[n("transition-group",{attrs:{"enter-class":"hidden","enter-to-class":"","enter-active-class":"","leave-class":"show","leave-active-class":"","leave-to-class":"hidden"},on:{"after-enter":t.focusFirst}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.is_visible,expression:"is_visible"}],key:"modal",ref:"modal",class:["modal",{fade:!t.noFade,show:t.is_visible}],attrs:{id:t.id||null,role:"dialog"},on:{click:function(e){t.onClickOut()},keyup:function(e){return"button"in e||!t._k(e.keyCode,"esc",27)?void t.onEsc():null}}},[n("div",{class:["modal-dialog","modal-"+t.size]},[n("div",{ref:"content",staticClass:"modal-content",attrs:{tabindex:"-1",role:"document","aria-labelledby":t.hideHeader||!t.id?null:t.id+"__BV_title_","aria-describedby":t.id?t.id+"__BV_body_":null},on:{click:function(t){t.stopPropagation()}}},[t.hideHeader?t._e():n("header",{ref:"header",staticClass:"modal-header"},[t._t("modal-header",[n("h5",{staticClass:"modal-title",attrs:{id:t.id?t.id+"__BV_title_":null}},[t._t("modal-title",[t._v(t._s(t.title))])],2),t.hideHeaderClose?t._e():n("button",{staticClass:"close",attrs:{type:"button","aria-label":t.closeTitle},on:{click:t.hide}},[n("span",{attrs:{"aria-hidden":"true"}},[t._v("×")])])])],2),n("div",{ref:"body",staticClass:"modal-body",attrs:{id:t.id?t.id+"__BV_body_":null}},[t._t("default")],2),t.hideFooter?t._e():n("footer",{ref:"footer",staticClass:"modal-footer"},[t._t("modal-footer",[t.okOnly?t._e():n("b-btn",{attrs:{variant:"secondary"},on:{click:function(e){t.hide(!1)}}},[t._v(t._s(t.closeTitle))]),n("b-btn",{attrs:{variant:"primary"},on:{click:function(e){t.hide(!0)}}},[t._v(t._s(t.okTitle))])])],2)])])]),t.is_visible?n("div",{key:"modal-backdrop",class:["modal-backdrop",{fade:!t.noFade,show:t.is_visible}]}):t._e()])],1)},staticRenderFns:[],_scopeId:"data-v-1b4cbb68",components:{bBtn:bBtn},data:function(){return{is_visible:!1,return_focus:this.returnFocus||null}},model:{prop:"visible",event:"change"},computed:{body:function(){if("undefined"!=typeof document)return document.querySelector("body")}},watch:{visible:function(t,e){t!==e&&(t?this.show():this.hide())}},props:{id:{type:String,default:null},title:{type:String,default:""},size:{type:String,default:"md"},noFade:{type:Boolean,default:!1},noCloseOnBackdrop:{type:Boolean,default:!1},noCloseOnEsc:{type:Boolean,default:!1},hideHeader:{type:Boolean,default:!1},hideFooter:{type:Boolean,default:!1},okOnly:{type:Boolean,default:!1},hideHeaderClose:{type:Boolean,default:!1},visible:{type:Boolean,default:!1},returnFocus:{default:null},closeTitle:{type:String,default:"Close"},okTitle:{type:String,default:"OK"}},methods:{show:function(){this.is_visible||(this.is_visible=!0,this.$root.$emit("shown::modal",this.id),this.body.classList.add("modal-open"),this.$emit("shown"),this.$emit("change",!0),"undefined"!=typeof document&&(document.removeEventListener("focusin",this.enforceFocus,!1),document.addEventListener("focusin",this.enforceFocus,!1)))},hide:function(t){if(this.is_visible){var e=!1,n={isOK:t,cancel:function(){e=!0}};this.$emit("change",!1),this.$emit("hidden",n),t===!0?this.$emit("ok",n):t===!1&&this.$emit("cancel",n),e||("undefined"!=typeof document&&(document.removeEventListener("focusin",this.enforceFocus,!1),this.returnFocusTo()),this.is_visible=!1,this.$root.$emit("hidden::modal",this.id),this.body.classList.remove("modal-open"))}},onClickOut:function(){this.is_visible&&!this.noCloseOnBackdrop&&this.hide()},onEsc:function(){this.is_visible&&!this.noCloseOnEsc&&this.hide()},focusFirst:function(){if(!document.activeElement||!this.$refs.content.contains(document.activeElement)){var t;this.$refs.footer&&(t=this.$refs.footer.querySelector(FOCUS_SELECTOR)),!t&&this.$refs.body&&(t=this.$refs.body.querySelector(FOCUS_SELECTOR)),!t&&this.$refs.header&&(t=this.$refs.header.querySelector(FOCUS_SELECTOR)),t||(t=this.$refs.content),t&&t.focus&&t.focus()}},returnFocusTo:function(){if(this.return_focus){var t="string"==typeof this.return_focus?document.querySelector(this.returnFocus):this.return_focus;t&&t.$el&&"function"==typeof t.$el.focus?t.$el.focus():t&&"function"==typeof t.focus&&t.focus()}},enforceFocus:function(t){this.is_visible&&document!==t.target&&this.$refs.content&&this.$refs.content!==t.target&&!this.$refs.content.contains(t.target)&&this.$refs.content.focus()}},created:function(){var t=this;this.$root.$on("show::modal",function(e,n){e===t.id&&(t.return_focus=n||t.return_focus||t.returnFocus||null,t.show())}),this.$root.$on("hide::modal",function(e){e===t.id&&t.hide()})},mounted:function(){this.visible===!0&&this.show()},destroyed:function(){"undefined"!=typeof document&&document.removeEventListener("focusin",this.enforceFocus,!1)}},nav={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n(t.type,{tag:"component",class:t.classObject,attrs:{role:t.isNavBar?null:"navigation"}},[t._t("default")],2)},staticRenderFns:[],computed:{classObject:function(){return{nav:!0,"navbar-nav":this.isNavBar,"nav-tabs":this.tabs,"nav-pills":this.pills,"flex-column":this.vertical,"nav-fill":this.fill}}},props:{type:{type:String,default:"ul"},fill:{type:Boolean,default:!1},tabs:{type:Boolean,default:!1},pills:{type:Boolean,default:!1},vertical:{type:Boolean,default:!1},isNavBar:{type:Boolean,default:!1}}},navItem={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("li",{staticClass:"nav-item"},[n("b-link",{staticClass:"nav-link",attrs:{active:t.active,disabled:t.disabled,href:t.href,to:t.to,target:t.target,rel:t.rel,tag:t.tag,exact:t.exact,append:t.append,replace:t.replace,"active-class":t.activeClass,"exact-active-class":t.exactActiveClass,event:t.event},on:{click:function(e){t.$emit("click")}}},[t._t("default")],2)],1)},staticRenderFns:[],components:{bLink:bLink},mixins:[linkMixin]},navItemDropdown={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("li",{class:["nav-item","dropdown",{dropup:t.dropup,show:t.visible}]},[n("a",{ref:"button",class:["nav-link",t.dropdownToggle,{disabled:t.disabled}],attrs:{href:"#",id:t.id?t.id+"__BV_button_":null,"aria-haspopup":"true","aria-expanded":t.visible?"true":"false",disabled:t.disabled},on:{click:function(e){e.stopPropagation(),e.preventDefault(),t.toggle(e)},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"enter",13)?(e.stopPropagation(),e.preventDefault(),void t.toggle(e)):null},function(e){return"button"in e||!t._k(e.keyCode,"space",32)?(e.stopPropagation(),e.preventDefault(),void t.toggle(e)):null}]}},[t._t("text",[n("span",{domProps:{innerHTML:t._s(t.text)}})])],2),n("div",{ref:"menu",class:["dropdown-menu",{"dropdown-menu-right":t.right}],attrs:{role:"menu","aria-labelledby":t.id?t.id+"__BV_button_":null},on:{keyup:function(e){return"button"in e||!t._k(e.keyCode,"esc",27)?void t.onEsc(e):null},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"tab",9)?void t.onTab(e):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38)?void t.focusNext(e,!0):null},function(e){return"button"in e||!t._k(e.keyCode,"down",40)?void t.focusNext(e,!1):null}],mouseover:function(e){t.focusHovered(e)}}},[t._t("default")],2)])},staticRenderFns:[],mixins:[clickOut,dropdown],data:function(){return{visible:!1}},computed:{dropdownToggle:function(){return this.caret?"dropdown-toggle":""}},props:{id:{type:String},caret:{type:Boolean,default:!0}},methods:{clickOutListener:function(){this.visible=!1}}},navToggle={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("button",{class:t.classObject,attrs:{type:"button","aria-label":t.label,"aria-controls":t.target.id?t.target.id:t.target,"aria-expanded":t.toggleState?"true":"false"},on:{click:t.onclick}},[n("span",{staticClass:"navbar-toggler-icon"})])},staticRenderFns:[],computed:{classObject:function(){return["navbar-toggler","navbar-toggler-"+this.position]}},data:function(){return{toggleState:!1}},props:{label:{type:String,default:"Toggle navigation"},position:{type:String,default:"right"},target:{required:!0}},methods:{onclick:function(){var t=this.target;t.toggle&&t.toggle(),this.$root.$emit("collapse::toggle",this.target)}},created:function(){var t=this;this.$root.$on("collapse::toggle::state",function(e,n){e!==t.target&&e!==t.target.id||(t.toggleState=n)})}},navbar={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("nav",{class:t.classObject},[t._t("default")],2)},staticRenderFns:[],computed:{classObject:function(){return["navbar",this.type?"navbar-"+this.type:null,this.variant?"bg-"+this.variant:null,this.fixed?"fixed-"+this.fixed:null,this.sticky?"sticky-top":null,this.toggleable?this.toggleableClass:null]},toggleableClass:function(){var t="navbar-toggleable";return this.toggleBreakpoint&&(t+="-"+this.toggleBreakpoint),t}},props:{type:{type:String,default:"light"},variant:{type:String},toggleable:{type:Boolean,default:!1},toggleBreakpoint:{type:String,default:null},fixed:{type:String},sticky:{type:String}}},bPagination={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:["btn-group","pagination",t.btnSize],attrs:{role:"group",tabindex:"0","aria-label":t.ariaLabel?t.ariaLabel:null},on:{focusin:function(e){return e.target!==e.currentTarget?null:void t.focusCurrent(e)},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"left",37)?"button"in e&&0!==e.button?null:(e.preventDefault(),void t.focusPrev(e)):null},function(e){return"button"in e||!t._k(e.keyCode,"right",39)?"button"in e&&2!==e.button?null:(e.preventDefault(),void t.focusNext(e)):null},function(e){return("button"in e||!t._k(e.keyCode,"left",37))&&e.shiftKey?"button"in e&&0!==e.button?null:(e.preventDefault(),void t.focusFirst(e)):null},function(e){return("button"in e||!t._k(e.keyCode,"right",39))&&e.shiftKey?"button"in e&&2!==e.button?null:(e.preventDefault(),void t.focusLast(e)):null}]}},[n("button",{ref:"buttonPrev",class:["btn","btn-"+t.secondaryVariant],attrs:{type:"button",disabled:t.isActive(1),"aria-label":t.labelPrevPage,tabindex:"-1"},on:{click:function(e){e.preventDefault(),t.isActive(1)?t._return:t.currentPage--}}},[n("span",{attrs:{"aria-hidden":"true"}},[t._v("«")])]),t._v(" "),t.showPrev?n("button",{ref:"buttonFirst",class:["btn","btn-"+t.secondaryVariant,t.isActive(1)?"active":""],attrs:{type:"button","aria-label":t.labelPage+" 1","aria-current":t.isActive(1)?"true":"false","aria-setsize":t.numberOfPages,"aria-posinset":1,tabindex:"-1"},on:{click:function(e){e.preventDefault(),t.currentPage=1}}},[t._v("1")]):t._e(),t._v(" "),n("span",{directives:[{name:"show",rawName:"v-show",value:t.showPrev,expression:"showPrev"}],class:["btn","btn-"+t.secondaryVariant]},[t._v("...")]),t._v(" "),t._l(t.pageLinks,function(e,i){return n("button",{ref:"buttonPages",refInFor:!0,class:["btn",t.btnVariant(i),t.isActive(i+t.diff)?"active":"",t.isActive(i+t.diff)?"":"hidden-xs-down"],attrs:{type:"button","aria-label":t.labelPage+" "+(i+t.diff),"aria-current":t.isActive(i+t.diff)?"true":"false","aria-setsize":t.numberOfPages,"aria-posinset":i+t.diff,tabindex:"-1"},on:{click:function(e){e.preventDefault(),t.currentPage=i+t.diff}}},[t._v(t._s(i+t.diff))])}),t._v(" "),n("span",{directives:[{name:"show",rawName:"v-show",value:t.showNext,expression:"showNext"}],class:["btn","btn-"+t.secondaryVariant]},[t._v("...")]),t._v(" "),t.showNext?n("button",{ref:"buttonLast",class:["btn","btn-"+t.secondaryVariant,t.isActive(t.numberOfPages)?"active":""],attrs:{type:"button","aria-label":t.labelPage+" "+t.numberOfPages,"aria-current":t.isActive(t.numberOfPages)?"true":"false","aria-setsize":t.numberOfPages,"aria-posinset":t.numberOfPages,tabindex:"-1"},on:{click:function(e){e.preventDefault(),t.currentPage=t.numberOfPages}}},[t._v(t._s(t.numberOfPages))]):t._e(),t._v(" "),n("button",{ref:"buttonNext",class:["btn","btn-"+t.secondaryVariant],attrs:{type:"button",disabled:t.isActive(t.numberOfPages),"aria-label":t.labelNextPage,tabindex:"-1"},on:{click:function(e){e.preventDefault(),t.isActive(t.numberOfPages)?t._return:t.currentPage++}}},[n("span",{attrs:{"aria-hidden":"true"}},[t._v("»")])])],2)},staticRenderFns:[],data:function(){return{diff:1,showPrev:!1,showNext:!1,currentPage:this.value}},computed:{numberOfPages:function(){var t=Math.ceil(this.totalRows/this.perPage);return t<1?1:t},btnSize:function(){return this.size&&"default"!==this.size?"pagination-"+this.size:""},pageLinks:function(){return this.currentPage>this.numberOfPages&&(this.currentPage=1),this.diff=1,this.showPrev=!1,this.showNext=!1,this.numberOfPages<=this.limit?this.numberOfPages:this.currentPage<=this.limit-2?(this.diff=1,this.showNext=!0,this.limit-2):this.currentPage>this.numberOfPages-this.limit+2?(this.diff=this.numberOfPages-this.limit+3,this.showPrev=!0,this.limit-2):(this.diff=this.currentPage-1,this.showPrev=this.currentPage>=this.limit,this.showNext=this.currentPage<=this.numberOfPages-this.limit+1,this.limit)}},methods:{isActive:function(t){return t===this.currentPage},btnVariant:function(t){return t+this.diff===this.currentPage?"btn-"+this.variant:"btn-"+this.secondaryVariant},getButtons:function(){var t=[this.$refs.buttonPrev];return this.showPrev&&t.push(this.$refs.buttonFirst),t=t.concat(this.$refs.buttonPages),this.showNext&&t.push(this.$refs.buttonLast),t.push(this.$refs.buttonNext),t},setBtnFocus:function(t){this.$nextTick(function(){t.focus()})},focusFirst:function(){var t=this.getButtons().find(function(t){return!t.disabled});t&&t.focus&&t!==document.activeElement&&this.setBtnFocus(t)},focusLast:function(){var t=this.getButtons().reverse().find(function(t){return!t.disabled});t&&t.focus&&t!==document.activeElement&&this.setBtnFocus(t)},focusCurrent:function(){var t=this,e=this.getButtons().find(function(e){return parseInt(e.getAttribute("aria-posinset"),10)===t.currentPage});e&&e.focus?this.setBtnFocus(e):this.focusFirst()},focusPrev:function(){var t=this.getButtons(),e=t.indexOf(document.activeElement);e>0&&!t[e-1].disabled&&t[e-1].focus&&this.setBtnFocus(t[e-1])},focusNext:function(){var t=this.getButtons(),e=t.indexOf(document.activeElement),n=t.length-1;e<n&&!t[e+1].disabled&&t[e+1].focus&&this.setBtnFocus(t[e+1])},_return:function(){}},watch:{currentPage:function(t,e){t!==e&&this.$emit("input",t)},value:function(t,e){t!==e&&(this.currentPage=t)}},props:{value:{type:Number,default:1},limit:{type:Number,default:3},perPage:{type:Number,default:20},totalRows:{type:Number,default:20},size:{type:String,default:"md"},variant:{type:String,default:"primary"},secondaryVariant:{type:String,default:"secondary"},ariaLabel:{type:String,default:"Pagination"},labelPrevPage:{type:String,default:"Previous Page"},labelNextPage:{type:String,default:"Next Page"},labelPage:{type:String,default:"Page"}}},TRIGGER_LISTENERS={click:{click:"toggle"},hover:{mouseenter:"show",mouseleave:"hide"},focus:{focus:"show",blur:"hide"}},PLACEMENT_PARAMS={top:"bottom center",bottom:"top center",left:"middle right",right:"middle left"},TETHER_CLASS_PREFIX="bs-tether",TETHER_CLASSES={element:!1,enabled:!1},TRANSITION_DURATION=150,bPopover={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[n("span",{ref:"trigger"},[t._t("default")],2),n("div",{ref:"popover",staticClass:"popover fade",class:[t.classState?"show":"",t.popoverAlignment],style:t.popoverStyle,attrs:{tabindex:"-1"},on:{focus:function(e){t.$emit("focus")},blur:function(e){t.$emit("blur")}}},[n("div",{staticClass:"popover-arrow"}),t.title?n("h3",{staticClass:"popover-title",domProps:{innerHTML:t._s(t.title)}}):t._e(),n("div",{staticClass:"popover-content"},[n("div",{staticClass:"popover-content-wrapper"},[t._t("content",[n("span",{domProps:{innerHTML:t._s(t.content)}})])],2)])])])},staticRenderFns:[],props:{constraints:{type:Array,default:function(){return[]}},content:{type:String,default:""},debounce:{type:[Number],default:300,validator:function(t){return t>=0}},delay:{type:[Number,Object],default:0,validator:function(t){return"number"==typeof t?t>=0:null!==t&&"object"==typeof t&&("number"==typeof t.show&&"number"==typeof t.hide&&t.show>=0&&t.hide>=0)}},offset:{type:String,default:"0 0",validator:function(t){return/^((0\s?)|([+-]?[0-9]+(px|%)\s?)){2}$/.test(t)}},placement:{type:String,default:"top",validator:function(t){return Object.keys(PLACEMENT_PARAMS).indexOf(t)!==-1}},popoverStyle:{type:Object,default:null},show:{type:Boolean,default:null},targetOffset:{type:String,default:"0 0",validator:function(t){return/^((0\s?)|([+-]?[0-9]+(px|%)\s?)){2}$/.test(t)}},title:{type:String,default:""},triggers:{type:[Boolean,String,Array],default:function(){return["click","focus"]},validator:function(t){if(t===!1||""===t)return!0;if("string"==typeof t)return Object.keys(TRIGGER_LISTENERS).indexOf(t)!==-1;if(Array.isArray(t)){var e=Object.keys(TRIGGER_LISTENERS);return t.forEach(function(t){if(e.indexOf(t)===-1)return!1}),!0}return!1}}},data:function(){return{triggerState:this.show,classState:this.show,lastEvent:null}},computed:{normalizedTriggers:function(){return this.triggers===!1?[]:"string"==typeof this.triggers?[this.triggers]:this.triggers},popoverAlignment:function(){return this.placement&&"default"!==this.placement?"popover-"+this.placement:"popover-top"},showState:function(){return this.show!==!1&&(this.triggerState||this.show)}},watch:{constraints:function(){this.setOptions()},normalizedTriggers:function(t,e){this.updateListeners(t,e)},offset:function(){
this.setOptions()},placement:function(){this.setOptions()},showState:function(t){var e=this,n=this.getDelay(t);clearTimeout(this._timeout),n?this._timeout=setTimeout(function(){return e.togglePopover(t)},n):this.togglePopover(t)}},methods:{addListener:function(t){var e=this;for(var n in TRIGGER_LISTENERS[t])e._trigger.addEventListener(n,function(t){return e.eventHandler(t)})},destroyTether:function(){if(this._tether&&!this.showState){this._tether.destroy(),this._tether=null;var t=new RegExp("(^|[^-]\\b)("+TETHER_CLASS_PREFIX+"\\S*)","g");this._trigger.className=this._trigger.className.replace(t,"")}},eventHandler:function(t){var e=this;if(!(this.normalizedTriggers.length>1&&this.debounce>0&&null!==this.lastEvent&&t.timeStamp<=this.lastEvent+this.debounce))for(var n in TRIGGER_LISTENERS)for(var i in TRIGGER_LISTENERS[n])if(i===t.type){var s=TRIGGER_LISTENERS[n][i];return void(("toggle"===s||e.triggerState&&"hide"===s||!e.triggerState&&"show"===s)&&(e.triggerState=!e.triggerState,e.lastEvent=t.timeStamp))}},getDelay:function(t){return"object"==typeof this.delay?t?this.delay.show:this.delay.hide:this.delay},getTetherOptions:function(){return{attachment:PLACEMENT_PARAMS[this.placement],element:this._popover,target:this._trigger,classes:TETHER_CLASSES,classPrefix:TETHER_CLASS_PREFIX,offset:this.offset,constraints:this.constraints,targetOffset:this.targetOffset}},hidePopover:function(){var t=this;this.classState=!1,clearTimeout(this._timeout),this._timeout=setTimeout(function(){t._popover.style.display="none",t.destroyTether()},TRANSITION_DURATION)},refreshPosition:function(){var t=this;this._tether&&this.$nextTick(function(){t._tether.position()})},removeListener:function(t){var e=this;for(var n in TRIGGER_LISTENERS[t])e._trigger.removeEventListener(n,function(t){return e.eventHandler(t)})},setOptions:function(){this._tether&&this._tether.setOptions(this.getTetherOptions())},showPopover:function(){var e=this;clearTimeout(this._timeout),this._tether||(this._tether=new __WEBPACK_IMPORTED_MODULE_0_tether___default.a(this.getTetherOptions())),this._popover.style.display="block",this.refreshPosition(),this.$nextTick(function(){e.classState=!0})},togglePopover:function(t){this.$emit("showChange",t),t?(this.showPopover(),this.$root.$emit("shown::popover")):(this.hidePopover(),this.$root.$emit("hidden::popover"))},updateListeners:function(t,e){var n=this;void 0===e&&(e=[]);var i=[],s=[];t.forEach(function(t){e.indexOf(t)===-1&&i.push(t)}),e.forEach(function(e){t.indexOf(e)===-1&&s.push(e)}),i.forEach(function(t){return n.addListener(t)}),s.forEach(function(t){return n.removeListener(t)})}},created:function(){var t=this;this.$root.$on("hide::popover",function(){t.triggerState=!1})},mounted:function(){this._trigger=this.$refs.trigger.children[0]||this.$refs.trigger,this._popover=this.$refs.popover,this._popover.style.display="none",this._timeout=0,this.updateListeners(this.normalizedTriggers),this.showState&&this.showPopover()},updated:function(){this.refreshPosition()},beforeDestroy:function(){var t=this;this.normalizedTriggers.forEach(function(e){return t.removeListener(e)}),clearTimeout(this._timeout),this.destroyTether()},destroyed:function(){this._popover.parentElement===document.body&&document.body.removeChild(this._popover)}},progress={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"progress"},[n("transition",[n("div",{class:t.classObject,style:t.styleObject,attrs:{role:"progressbar","aria-valuenow":t.value,"aria-valuemin":0,"aria-valuemax":t.max}},[t._t("default",[t.showProgress?[t._v(t._s(t.progress)+"%")]:t.showValue?[t._v(t._s(t.value))]:t._e()])],2)])],1)},staticRenderFns:[],computed:{classObject:function(){return["progress-bar",this.progressVariant,this.striped||this.animated?"progress-bar-striped":"",this.animated?"progress-bar-animated":""]},styleObject:function(){return{width:this.progress+"%"}},progressVariant:function(){return this.variant?"bg-"+this.variant:null},progress:function(){var t=Math.pow(10,this.precision);return Math.round(100*t*this.value/this.max)/t}},props:{striped:{type:Boolean,default:!1},animated:{type:Boolean,default:!1},precision:{type:Number,default:0},value:{type:Number,default:0},max:{type:Number,default:100},variant:{type:String,default:null},showProgress:{type:Boolean,default:!1},showValue:{type:Boolean,default:!1}}},toString=function(t){return t?t instanceof Object?Object.keys(t).map(function(e){return toString(t[e])}).join(" "):String(t):""},defaultSortCompare=function(t,e,n){return toString(t[n]).localeCompare(toString(e[n]),void 0,{numeric:!0})},table={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("table",{class:t.tableClass,attrs:{id:t.id||null,role:"grid"}},[n("thead",{class:t.headVariant?"thead-"+t.headVariant:""},[n("tr",{attrs:{role:"row"}},t._l(t.fields,function(e,i){return n("th",{class:t.fieldClass(e,i),attrs:{"aria-label":e.sortable?t.sortDesc?t.labelSortAsc:t.labelSortDesc:null,"aria-sort":e.sortable&&t.sortBy===i?t.sortDesc?"descending":"ascending":null,tabindex:e.sortable?"0":null},domProps:{innerHTML:t._s(e.label)},on:{click:function(n){t.headClick(e,i)},keydown:[function(n){return"button"in n||!t._k(n.keyCode,"enter",13)?void t.headClick(e,i):null},function(n){return"button"in n||!t._k(n.keyCode,"space",32)?(n.preventDefault(),void t.headClick(e,i)):null}]}})}))]),t.footClone?n("tfoot",{class:t.footVaraiant?"thead-"+t.footVariant:""},[n("tr",{attrs:{role:"row"}},t._l(t.fields,function(e,i){return n("th",{class:t.fieldClass(e,i),attrs:{"aria-label":e.sortable?t.sortDesc?t.labelSortAsc:t.labelSortDesc:null,"aria-sort":e.sortable&&t.sortBy===i?t.sortDesc?"descending":"ascending":null,tabindex:e.sortable?"0":null},domProps:{innerHTML:t._s(e.label)},on:{click:function(n){t.headClick(e,i)},keydown:[function(n){return"button"in n||!t._k(n.keyCode,"enter",13)?void t.headClick(e,i):null},function(n){return"button"in n||!t._k(n.keyCode,"space",32)?(n.preventDefault(),void t.headClick(e,i)):null}]}})}))]):t._e(),n("tbody",[t._l(t._items,function(e,i){return n("tr",{key:t.items_key,class:[e.state?"table-"+e.state:null],attrs:{role:"row"},on:{click:function(n){t.rowClicked(e,i)}}},t._l(t.fields,function(s,o){return n("td",{class:[s.class?s.class:null]},[t._t(o,[t._v(t._s(e[o]))],{value:e[o],item:e,index:i})],2)}))}),t.showEmpty&&0===t.items.length?n("tr",{attrs:{colspan:Object.keys(t.fields).length,role:"row"}},[t._t("empty",[n("div",{staticClass:"text-center",domProps:{innerHTML:t._s(t.emptyText)}})])],2):t.showEmpty&&0===t._items.length?n("tr",{attrs:{colspan:Object.keys(t.fields).length,role:"row"}},[t._t("emptyfiltered",[n("div",{staticClass:"text-center",domProps:{innerHTML:t._s(t.emptyFilteredText)}})])],2):t._e()],2)],1)},staticRenderFns:[],components:{bPagination:bPagination},data:function(){return{sortBy:null,sortDesc:!0}},props:{id:{type:String,default:""},items:{type:Array,default:function(){return[]}},fields:{type:Object,default:function(){}},striped:{type:Boolean,default:!1},bordered:{type:Boolean,default:!1},inverse:{type:Boolean,default:!1},hover:{type:Boolean,default:!1},small:{type:Boolean,default:!1},responsive:{type:Boolean,default:!1},headVariant:{type:String,default:""},footVariant:{type:String,default:""},perPage:{type:Number,default:null},items_key:{type:String,default:null},currentPage:{type:Number,default:1},filter:{type:[String,RegExp,Function],default:null},sortCompare:{type:Function,default:null},itemsProvider:{type:Function,default:null},value:{type:Array,default:function(){return[]}},footClone:{type:Boolean,default:!1},labelSortAsc:{type:String,default:"Click to sort Ascending"},labelSortDesc:{type:String,default:"Click to sort Descending"},showEmpty:{type:Boolean,default:!1},emptyText:{type:String,default:"There are no records to show"},emptyFilteredText:{type:String,default:"There are no records matching your request"}},computed:{tableClass:function(){return["table",this.striped?"table-striped":"",this.hover?"table-hover":"",this.inverse?"table-inverse":"",this.bordered?"table-bordered":"",this.responsive?"table-responsive":"",this.small?"table-sm":""]},_items:function(){var t=this;if(!this.items)return[];if(this.itemsProvider)return this.itemsProvider(this);var e=this.items.slice();if(this.filter)if(this.filter instanceof Function)e=e.filter(this.filter);else{var n;n=this.filter instanceof RegExp?this.filter:new RegExp(".*"+this.filter+".*","ig"),e=e.filter(function(t){var e=n.test(toString(t));return n.lastIndex=0,e})}var i=this.sortCompare||defaultSortCompare;return this.sortBy&&(e=e.sort(function(e,n){var s=i(e,n,t.sortBy);return t.sortDesc?s:s*-1})),this.$emit("input",e),this.perPage&&(e=e.slice((this.currentPage-1)*this.perPage,this.currentPage*this.perPage)),e}},methods:{fieldClass:function(t,e){return[t.sortable?"sorting":"",t.sortable&&this.sortBy===e?"sorting_"+(this.sortDesc?"desc":"asc"):"",t.class?t.class:"",t.invisible?"invisible":""]},rowClicked:function(t,e){this.$emit("row-clicked",t,e)},headClick:function(t,e){return t.sortable?(e===this.sortBy&&(this.sortDesc=!this.sortDesc),void(this.sortBy=e)):void(this.sortBy=null)}}},tabs={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n(t.tag,{tag:"component",staticClass:"tabs",attrs:{id:t.id||null}},[t.bottom?n("div",{ref:"tabsContainer",class:["tab-content",{"card-block":t.card}]},[t._t("default"),t.tabs&&t.tabs.length?t._e():t._t("empty")],2):t._e(),n("div",{class:{"card-header":t.card}},[n("ul",{class:["nav","nav-"+t.navStyle,t.card?"card-header-"+t.navStyle:null],attrs:{role:"tablist",tabindex:"0","aria-setsize":t.tabs.length,"aria-posinset":t.currentTab+1},on:{keydown:[function(e){return"button"in e||!t._k(e.keyCode,"left",37)?"button"in e&&0!==e.button?null:void t.previousTab(e):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38)?void t.previousTab(e):null},function(e){return"button"in e||!t._k(e.keyCode,"right",39)?"button"in e&&2!==e.button?null:void t.nextTab(e):null},function(e){return"button"in e||!t._k(e.keyCode,"down",40)?void t.nextTab(e):null},function(e){return("button"in e||!t._k(e.keyCode,"left",37))&&e.shiftKey?"button"in e&&0!==e.button?null:void t.setTab(-1,!1,1):null},function(e){return("button"in e||!t._k(e.keyCode,"up",38))&&e.shiftKey?void t.setTab(-1,!1,1):null},function(e){return("button"in e||!t._k(e.keyCode,"right",39))&&e.shiftKey?"button"in e&&2!==e.button?null:void t.setTab(t.tabs.length,!1,-1):null},function(e){return("button"in e||!t._k(e.keyCode,"down",40))&&e.shiftKey?void t.setTab(t.tabs.length,!1,-1):null}]}},[t._l(t.tabs,function(e,i){return n("li",{staticClass:"nav-item",attrs:{role:"presentation"}},[e.headHtml?n("div",{class:["tab-head",{small:t.small,active:e.localActive,disabled:e.disabled}],attrs:{role:"heading",tabindex:"-1"},domProps:{innerHTML:t._s(e.headHtml)}}):n("a",{class:["nav-link",{small:t.small,active:e.localActive,disabled:e.disabled}],attrs:{href:e.href,role:"tab","aria-selected":e.localActive?"true":"false","aria-controls":e.id||null,id:e.controlledBy||null,tabindex:"-1"},domProps:{innerHTML:t._s(e.title)},on:{click:function(e){e.preventDefault(),e.stopPropagation(),t.setTab(i)},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"space",32)?(e.preventDefault(),e.stopPropagation(),void t.setTab(i)):null},function(e){return"button"in e||!t._k(e.keyCode,"enter",13)?(e.preventDefault(),e.stopPropagation(),void t.setTab(i)):null}]}})])}),t._t("tabs")],2)]),t.bottom?t._e():n("div",{ref:"tabsContainer",class:["tab-content",{"card-block":t.card}]},[t._t("default"),t.tabs&&t.tabs.length?t._e():t._t("empty")],2)])},staticRenderFns:[],data:function(){return{currentTab:this.value,tabs:[]}},props:{id:{type:String,default:""},tag:{type:String,default:"div"},noFade:{type:Boolean,default:!1},card:{type:Boolean,default:!1},small:{type:Boolean,default:!1},value:{type:Number,default:0},pills:{type:Boolean,default:!1},lazy:{type:Boolean,default:!1},bottom:{type:Boolean,default:!1}},watch:{currentTab:function(t,e){t!==e&&(this.$root.$emit("changed::tab",this,t,this.tabs[t]),this.$emit("input",t),this.tabs[t].$emit("click"))},value:function(t,e){t!==e&&this.setTab(t)},fade:function(t,e){var n=this;t!==e&&this.tabs.forEach(function(e){n.$set(e,"fade",t)})}},computed:{fade:function(){return!this.noFade},navStyle:function(){return this.pills?"pills":"tabs"}},methods:{sign:function(t){return 0===t?0:t>0?1:-1},nextTab:function(){this.setTab(this.currentTab,!1,1)},previousTab:function(){this.setTab(this.currentTab,!1,-1)},setTab:function(t,e,n){if(n=n||0,e||t+n!==this.currentTab){var i=this.tabs[t+n];if(i){if(i.disabled)return void(n&&this.setTab(t,e,n+this.sign(n)));this.tabs[this.currentTab]&&this.$set(this.tabs[this.currentTab],"localActive",!1),this.$set(i,"localActive",!0),this.currentTab=t+n}}},updateTabs:function(){var t=this;this.$slots.default?this.tabs=this.$slots.default.filter(function(t){return t.componentInstance||!1}).map(function(t){return t.componentInstance}):this.tabs=[],this.tabs.forEach(function(e){t.$set(e,"fade",t.fade),t.$set(e,"lazy",t.lazy)});var e=this.currentTab;null!==this.currentTab&&void 0!==this.currentTab||this.tabs.forEach(function(t,n){t.active&&(e=n)});var n=0;e>this.tabs.length-1&&(n=-1),this.setTab(e||0,!0,n)}},mounted:function(){this.updateTabs(),observeDOM(this.$refs.tabsContainer,this.updateTabs.bind(this),{subtree:!1})}},tab={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("transition",{attrs:{mode:"out-in"},on:{enter:t.enter,"before-leave":t.beforeLeave}},[t.localActive||!t.lazy?n(t.tag,{directives:[{name:"show",rawName:"v-show",value:t.localActive||t.lazy,expression:"localActive || lazy"}],ref:"panel",tag:"component",class:["tab-pane",{show:t.show,fade:t.fade,disabled:t.disabled,active:t.localActive}],attrs:{id:t.id||null,role:"tabpanel","aria-hidden":t.localActive?"false":"true","aria-expanded":t.localActive?"true":"false","aria-lablelledby":t.controlledBy||null}},[t._t("default")],2):t._e()],1)},staticRenderFns:[],methods:{enter:function(){this.show=!0},beforeLeave:function(){this.show=!1}},data:function(){return{fade:!1,localActive:!1,lazy:!0,show:!1}},computed:{controlledBy:function(){return this.buttonId||(this.id?this.id+"__BV_tab_button__":null)}},props:{id:{type:String,default:""},tag:{type:String,default:"div"},buttonId:{type:String,default:""},title:{type:String,default:""},headHtml:{type:String,default:null},disabled:{type:Boolean,default:!1},active:{type:Boolean,default:!1},href:{type:String,default:"#"}}},tooltip={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[n("span",{ref:"trigger"},[t._t("default")],2),n("div",{ref:"popover",class:["tooltip","tooltip-"+this.placement],style:{opacity:t.showState?1:0},attrs:{tabindex:"-1"},on:{focus:function(e){t.$emit("focus")},blur:function(e){t.$emit("blur")}}},[n("div",{staticClass:"tooltip-inner"},[t._t("content",[n("span",{domProps:{innerHTML:t._s(t.content||t.title)}})])],2)])])},staticRenderFns:[],extends:bPopover,props:{triggers:{type:[Boolean,String,Array],default:"hover"}}},components=Object.freeze({bAlert:alert,bBreadcrumb:breadcrumb,bButton:bBtn,bBtn:bBtn,bButtonToolbar:buttonToolbar,bButtonGroup:buttonGroup,bButtonGroupDropdown:buttonGroupDropdown,bInputGroup:inputGroup,bInputGroupAddon:inputGroupAddon,bInputGroupButton:inputGroupButton,bCard:card,bCardGroup:cardGroup,bDropdown:dropdown$1,bDropdownItem:dropdownItem,bDropdownDivider:dropdownDivider,bDropdownHeader:dropdownHeader,bDropdownSelect:dropdownSelect,bForm:form,bFormCheckbox:formCheckbox,bFormFieldset:formFieldset,bFormFile:formFile,bFormRadio:formRadio,bFormInput:formInput,bFormInputStatic:bFormInputStatic,bFormSelect:formSelect,bJumbotron:jumbotron,bBadge:badge,bMedia:media,bModal:modal,bNavbar:navbar,bPagination:bPagination,bPopover:bPopover,bProgress:progress,bTable:table,bTooltip:tooltip,bTab:tab,bTabs:tabs,bNav:nav,bNavItem:navItem,bNavItemDropdown:navItemDropdown,bNavToggle:navToggle,bListGroupItem:listGroupItem,bListGroup:listGroup,bCarouselSlide:carouselSlide,bCarousel:carousel,bCollapse:collapse,bLink:bLink}),all_listen_types={hover:!0,click:!0,focus:!0},listen_types={click:!0},toggle={bind:function(t,e){targets(t,e,listen_types,function(t){var e=t.targets,n=t.vm;e.forEach(function(t){n.$root.$emit("collapse::toggle",t)})})}},listen_types$1={click:!0},modal$1={bind:function(t,e){targets(t,e,listen_types$1,function(e){var n=e.targets,i=e.vm;n.forEach(function(e){i.$root.$emit("show::modal",e,t)})})}},inBrowser$1="undefined"!=typeof window,isServer=!inBrowser$1;inBrowser$1&&window.Element&&!Element.prototype.closest&&(Element.prototype.closest=function(t){var e,n=(this.document||this.ownerDocument).querySelectorAll(t),i=this;do for(e=n.length;--e>=0&&n.item(e)!==i;);while(e<0&&(i=i.parentElement));return i});var NAME="v-b-scrollspy",EVENT="scrollspy::activate",BVSS="__BV_ScrollSpy__",Default={element:"body",offset:10,method:"auto",throttle:200},DefaultType={element:"(string|element)",offset:"number",method:"string",throttle:"number"},ClassName={DROPDOWN_ITEM:"dropdown-item",DROPDOWN_MENU:"dropdown-menu",DROPDOWN_TOGGLE:"dropdown-toggle",NAV_LINK:"nav-link",LIST_ITEM:"list-group-item",ACTIVE:"active"},Selector={ACTIVE:".active",NAV_LIST_GROUP:".nav, .list-group",NAV:".nav",LIST_GROUP:".list-group",NAV_LINKS:".nav-link",LIST_ITEMS:".list-group-item",DROPDOWN:".dropdown",DROPDOWN_ITEMS:".dropdown-item",DROPDOWN_TOGGLE:".dropdown-toggle"},OffsetMethod={OFFSET:"offset",POSITION:"position"};ScrollSpy.prototype.updateConfig=function(t){var e=this;t.arg&&(this._config.element="#"+t.arg),Object.keys(t.modifiers).forEach(function(t){/^\d+$/.test(t)?e._config.offset=parseInt(t,10):/^(auto|position|offset)$/.test(t)&&(e._config.method=t)}),"string"==typeof t.value?this._config.element=t.value:"number"==typeof t.value?this._config.offset=Math.round(t.value):"object"==typeof t.value&&Object.keys(t.value).filter(function(t){return Boolean(DefaultType[t])}).forEach(function(n){e._config[n]=t.value[n]}),typeCheckConfig(NAME,this._config,DefaultType);var n=getVm(this._$el);return n&&n.$root&&(this._$root=n.$root),this},ScrollSpy.prototype.listen=function(){var t=this._getScroller();return t&&("BODY"!==t.tagName&&t.addEventListener("scroll",this,!1),window.addEventListener("scroll",this,!1),window.addEventListener("orientationchange",this,!1),window.addEventListener("resize",this,!1)),this},ScrollSpy.prototype.unListen=function(){var t=this._getScroller();return t&&("BODY"!==t.tagName&&t.removeEventListener("scroll",this,!1),window.removeEventListener("scroll",this,!1),window.removeEventListener("orientationchange",this,!1),window.removeEventListener("resize",this,!1)),this},ScrollSpy.prototype.refresh=function(){var t=this,e=this._getScroller();if(!e)return this;var n="BODY"===e.tagName?OffsetMethod.OFFSET:OffsetMethod.POSITION,i="auto"===this._config.method?n:this._config.method,s=i===OffsetMethod.OFFSET?0:this._getScrollTop();return this._offsets=[],this._targets=[],this._scrollHeight=this._getScrollHeight(),$QSA(this._selector,this._$el).map(function(t){var n=t.getAttribute("href");if(n&&"#"===n.charAt(0)&&"#"!==n&&n.indexOf("#/")===-1){var o=$QS(n,e);if(!o)return null;var r=o.getBoundingClientRect();if(r.width||r.height)return{offset:(i===OffsetMethod.OFFSET?r.top:o.offsetTop)+s,href:n}}return null}).filter(function(t){return t}).sort(function(t,e){return t.offset-e.offset}).forEach(function(e){t._offsets.push(e.offset),t._targets.push(e.href)}),this},ScrollSpy.prototype.process=function(){var t=this;if(!this._getScroller)return this;var e=this._getScrollTop()+this._config.offset,n=this._getScrollHeight(),i=this._config.offset+n-this._getOffsetHeight();if(this._scrollHeight!==n&&this.refresh(),e>=i){var s=this._targets[this._targets.length-1];return this._activeTarget!==s&&this._activate(s),this}if(this._activeTarget&&e<this._offsets[0]&&this._offsets[0]>0)return this._activeTarget=null,this._clear(),this;for(var o=this._offsets.length;o--;){var r=t._activeTarget!==t._targets[o]&&e>=t._offsets[o]&&(void 0===t._offsets[o+1]||e<t._offsets[o+1]);r&&t._activate(t._targets[o])}return this},ScrollSpy.prototype.dispose=function(){this.unListen(),clearTimeout(this._resizeTimeout),this._resizeTimeout=null,this._$el=null,this._config=null,this._selector=null,this._offsets=null,this._targets=null,this._activeTarget=null,this._scrollHeight=null,this._$root=null},ScrollSpy.prototype.handleEvent=function(t){function e(){clearTimeout(this._resizeTimeout),this._resizeTimeout=setTimeout(function(){n.refresh().process()},n._config.throttle||Default.throttle)}var n=this;"scroll"===t.type?this.process():"orientationchange"===t.type?this.refresh().process():"resize"===t.type&&e()},ScrollSpy.prototype._getScroller=function(){if(isServer)return null;var t=this._config.element;return t?t&&isElement(t)?t:"string"==typeof t?"body"===t?document.body:$QS(t):null:null},ScrollSpy.prototype._getScrollTop=function(){var t=this._getScroller();return t?"BODY"===t.tagName?window.pageYOffset:t.scrollTop:0},ScrollSpy.prototype._getScrollHeight=function(){var t=this._getScroller();return t?"BODY"===t.tagName?Math.max(document.body.scrollHeight,document.documentElement.scrollHeight):t.scrollHeight:0},ScrollSpy.prototype._getOffsetHeight=function(){var t=this._getScroller();return t?"BODY"===t.tagName?window.innerHeight:t.getBoundingClientRect().height:0},ScrollSpy.prototype._activate=function(t){var e=this;this._activeTarget=t,this._clear();var n=this._selector.split(",");n=n.map(function(e){return e+'[href="'+t+'"]'});var i=$QSA(n.join(","),this._$el);i.forEach(function(t){if(t.classList.contains(ClassName.DROPDOWN_ITEM)){var n=closest(t,Selector.DROPDOWN);if(n){var i=$QS(Selector.DROPDOWN_TOGGLE,n);i&&e._setActiveState(i,!0)}e._setActiveState(t,!0)}else e._setActiveState(t,!0),e._setParentsSiblingActiveState(t,Selector.NAV_LIST_GROUP,[ClassName.NAV_LINK,ClassName.LIST_ITEM],!0)}),i&&i.length>0&&this._$root&&this._$root.$emit&&this._$root.$emit(EVENT,t)},ScrollSpy.prototype._clear=function(){var t=this;$QSA(this._selector,this._$el).filter(function(t){if(t.classList.contains(ClassName.ACTIVE)){var e=t.getAttribute("href");return"#"===e.charAt(0)&&0!==e.indexOf("#/")}return!1}).forEach(function(e){t._setActiveState(e,!1)})},ScrollSpy.prototype._setActiveState=function(t,e){if(t){t.classList.contains(ClassName.NAV_LINK)&&!t.classList.contains(ClassName.DROPDOWN_TOGGLE)&&(t=t.parentElement);var n=getVm(t);n&&Object.prototype.hasOwnProperty.call(n.$props,"active")?n.$props.active=e:t.classList[e?"add":"remove"](ClassName.ACTIVE)}},ScrollSpy.prototype._setParentsSiblingActiveState=function(t,e,n,i){var s=this;if(n){Array.isArray(n)||(n=[n]);for(var o=t;o;)if(o=closest(o,e),o&&o.previousElementSibling)for(var r=0;r<n.length-1;r++)o.previousElementSibling.classList.contains(n[r])&&s._setActiveState(o,i)}};var scrollspy={bind:function(t,e){isServer||t[BVSS]||(t[BVSS]=new ScrollSpy(t,e))},inserted:function(t,e){!isServer&&t[BVSS]&&t[BVSS].updateConfig(e).listen().refresh().process()},update:function(t,e){!isServer&&t[BVSS]&&t[BVSS].updateConfig(e).refresh().process()},componentUpdated:function(t,e){!isServer&&t[BVSS]&&t[BVSS].updateConfig(e).refresh().process()},unbind:function(t){!isServer&&t[BVSS]&&(t[BVSS].unListen().dispose(),t[BVSS]=null)}},directives=Object.freeze({bToggle:toggle,bModal:modal$1,bScrollspy:scrollspy}),VuePlugin={install:function(t){if(!t._bootstrap_vue_installed){t._bootstrap_vue_installed=!0;for(var e in components)t.component(e,components[e]);for(var n in directives)t.directive(n,directives[n])}}};"undefined"!=typeof window&&window.Vue&&window.Vue.use(VuePlugin);/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);
//# sourceMappingURL=bootstrap-vue.esm.js.map


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(26)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(23),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(27)
__webpack_require__(25)
__webpack_require__(24)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(22),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.13
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */


// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var componentOptions = vnode.componentOptions;
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  if (deep) {
    if (vnode.children) {
      cloned.children = cloneVNodes(vnode.children, true);
    }
    if (componentOptions && componentOptions.children) {
      componentOptions.children = cloneVNodes(componentOptions.children, true);
    }
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
].forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both micro and macro tasks.
// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
// micro tasks have too high a priority and fires in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using macro tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use micro task by default, but expose a way to force macro task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) Task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine MicroTask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a Task instead of a MicroTask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias,
  eventKeyName
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (keyCodes) {
    if (Array.isArray(keyCodes)) {
      return keyCodes.indexOf(eventKeyCode) === -1
    } else {
      return keyCodes !== eventKeyCode
    }
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm = Object.create(parent);
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    vnode.fnContext = contextVm;
    vnode.fnOptions = options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }

  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
        applyNS(child, ns, force);
      }
    }
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        // _rendered is a flag added by renderSlot, but may not be present
        // if the slot is passed from manually written render functions
        if (slot._rendered || (slot[0] && slot[0].elm)) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$1 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$1++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.5.13';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setAttribute(vnode.elm, i, '');
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.
      /* istanbul ignore if */
      if (
        isIE && !isIE9 &&
        el.tagName === 'TEXTAREA' &&
        key === 'placeholder' && !el.__ieph
      ) {
        var blocker = function (e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };
        el.addEventListener('input', blocker);
        // $flow-disable-line
        el.__ieph = true; /* IE placeholder patched */
      }
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = { value: value };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + value + "=$$a.concat([$$v]))}" +
      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    if (value$1) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
Vue$3.nextTick(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
var comment = /^<!--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!--([\s\S]*?)-->/g, '$1')
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}

function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (map['v-model'] && (map['v-bind:type'] || map[':type'])) {
      var typeBinding = getBindingAttr(el, 'type');
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$2
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? handler.value + '($event)'
      : isFunctionExpression
        ? ("(" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var code = keyCodes[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(code)) + "," +
    "$event.key)"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue$3.prototype.$mount;
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue$3.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3), __webpack_require__(21).setImmediate))

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer-dep'
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header-dep'
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dep49__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Footer_vue__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dep49__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#header-dep',
  render: function (h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__Header_vue___default.a);
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#footer-dep',
  render: function (h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__Footer_vue___default.a);
  }
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "#dep-autres-sites>a>button.btn{font-family:Century Gothic,Times New Roman,serif;background-color:#444;color:#fff;border:0;font-weight:700;font-size:.8rem!important}", ""]);

// exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports
exports.push([module.i, "@import url(http://fonts.googleapis.com/css?family=Roboto:400,500,400italic,500italic,700,700italic);", ""]);
exports.i(__webpack_require__(14), "");
exports.i(__webpack_require__(16), "");
exports.i(__webpack_require__(15), "");

// module
exports.push([module.i, "@media (min-width:1200px){.container{max-width:1280px}}body{margin:0}.dyslexia,.dyslexia *{font-family:OpenDyslexic\\ 3!important}.dyslexia #headerDyslexia,.dyslexia * #headerDyslexia{text-decoration:underline}.dyslexia * .headroom .dep-navigation ul.nav>li>a,.dyslexia .headroom .dep-navigation ul.nav>li>a{line-height:2em;padding-top:7%}.dyslexia * .headroom--not-top .dep-navigation ul.nav>li>a,.dyslexia .headroom--not-top .dep-navigation ul.nav>li>a{padding-top:0;line-height:2.8em}.dyslexia * .dep-filtres-recherche .nav,.dyslexia .dep-filtres-recherche .nav{width:28.75%}.dyslexia * .dep-filtres-recherche #header-dep-search .form-group,.dyslexia .dep-filtres-recherche #header-dep-search .form-group{margin-bottom:2.5%}.dyslexia * .menu-tools li a:focus .slide-text,.dyslexia * .menu-tools li a:hover .slide-text,.dyslexia .menu-tools li a:focus .slide-text,.dyslexia .menu-tools li a:hover .slide-text{width:8rem}.dyslexia * .menu-tools li a .slide-text,.dyslexia .menu-tools li a .slide-text{left:-8rem}.contrast{background:#fff!important;color:#000!important;-webkit-transition:all .5s ease;transition:all .5s ease}.contrast *{background-color:transparent!important;background-image:none!important;color:#000!important}.contrast * #headerContrast{text-decoration:underline}.contrast * .footer-dep *,.contrast * .headroom--not-top .dep-navigation,.contrast * .headroom--not-top .dep-navigation *,.contrast * .mfp-bg *,.contrast * .page-item.active .page-link,.contrast * .page-item.active .page-link:focus,.contrast * .page-item.active .page-link:hover{background:#000!important;background-color:#000!important;color:#fff!important}.contrast * #dep-menu-share,.contrast * #dep-skip-navigation,.contrast * .dep-navigation .subLevel0,.contrast * .dep-navigation .subLevel0 *,.contrast * .er-popup,.contrast * .footer-dep button{background:#fff!important;color:#000!important}.contrast * .headroom--not-top .logo-anjou{-webkit-transition:all .25s ease-in-out!important;transition:all .25s ease-in-out!important}.contrast * .dep-navigation .dep-expandable-searchbox *,.contrast * .dep-navigation .dep-expandable-searchbox input{background:transparent!important}.contrast * .dep-navigation .dep-expandable-searchbox .focus,.contrast * .dep-navigation .dep-expandable-searchbox :focus,.contrast * .dep-navigation .dep-expandable-searchbox input.focus,.contrast * .dep-navigation .dep-expandable-searchbox input:focus{background:#fff!important}.contrast * .dep-navigation .subLevel0 .subLevel-title a+a{color:#000!important}#header-dep,.footer-dep{font-family:Roboto,Arial,sans-serif;font-size:62.5%;font-weight:400;z-index:100000;position:relative}#header-dep .list-inline,.footer-dep .list-inline{list-style:none}#header-dep .list-inline-item,.footer-dep .list-inline-item{display:inline-block}#header-dep .btn,.footer-dep .btn{display:inline-block;padding:.375rem 1rem;font-size:1rem;font-weight:400;line-height:1.5;text-align:center;white-space:nowrap;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin:0}#header-dep .container-fluid,.footer-dep .container-fluid{padding-left:.5rem;padding-right:.5rem}#header-dep .container,.footer-dep .container{padding-left:4rem;padding-right:4rem}@media (max-width:1199px){#header-dep .container,.footer-dep .container{padding-left:0;padding-right:0}}#header-dep .container,#header-dep .container-fluid,.footer-dep .container,.footer-dep .container-fluid{margin-right:auto;margin-left:auto}#header-dep a,.footer-dep a{text-decoration:none}#header-dep a:focus,#header-dep a:hover,.footer-dep a:focus,.footer-dep a:hover{text-decoration:underline}#header-dep [role=button],#header-dep a,#header-dep button,.footer-dep [role=button],.footer-dep a,.footer-dep button{-ms-touch-action:manipulation;touch-action:manipulation}#header-dep .collapse,.footer-dep .collapse{display:none}#header-dep .collapse.in,.footer-dep .collapse.in{display:block}#header-dep .collapsing,.footer-dep .collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height;transition-property:height}#header-dep .dropdown-menu,.footer-dep .dropdown-menu{position:fixed;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:1rem;color:#373a3c;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}#header-dep .sr-only,.footer-dep .sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}#header-dep.headroom{background:#444}#header-dep.headroom:after,#header-dep.headroom:before{content:\" \";display:table}#header-dep.headroom:after{clear:both}#header-dep.headroom .dep-skip-navigation{position:absolute;left:0;top:-20em}#header-dep.headroom .dep-skip-navigation .container{float:none;width:auto}#header-dep.headroom .dep-skip-navigation.skip-focus{top:0;position:relative;color:#333;line-height:2;border-bottom:1px solid #ccc;font-size:1.1em;background:#fff;height:2rem}#header-dep.headroom .dep-skip-navigation ul{float:right!important}#header-dep.headroom .dep-skip-navigation ul .list-inline-item{margin:0;display:initial;line-height:2rem}#header-dep.headroom .dep-skip-navigation ul .list-inline-item:before{content:\"\\2022   \";color:#ccc;font-size:1.2em}#header-dep.headroom .dep-skip-navigation ul .list-inline-item:first-of-type:before{content:\" \"}#header-dep.headroom .dep-skip-navigation ul a{color:#333}#header-dep.headroom .dep-skip-navigation ul a:focus{position:static;width:auto;height:auto}#header-dep.headroom #dep-menu-share{background:#fff;border-bottom:1px solid #ccc;color:#333}#header-dep.headroom #dep-menu-share .container{margin:0 auto;-js-display:flex;display:-webkit-box;display:-webkit-flexbox;display:-ms-flexbox;display:flex;justify-content:center;align-items:center}@media (max-width:767px){#header-dep.headroom #dep-menu-share .container{display:block;text-align:center}}#header-dep.headroom #dep-menu-share p{font-size:1.4em;line-height:1.5;padding:0;margin:0}#header-dep.headroom #dep-menu-share .list-inline-item:not(:last-child){margin-right:0}#header-dep.headroom #dep-menu-share .dep-social-networks{display:block;color:#333;font-size:2em;padding:.5em}#header-dep.headroom #dep-menu-share .dep-social-networks a{color:#fff;background:#0c4e78;width:2rem;height:2rem;-js-display:flex;display:-webkit-box;display:-webkit-flexbox;display:-ms-flexbox;display:flex;align-items:center;justify-content:center;overflow:hidden;position:relative;z-index:1;text-decoration:none}#header-dep.headroom #dep-menu-share .dep-social-networks a:focus,#header-dep.headroom #dep-menu-share .dep-social-networks a:hover{text-decoration:none}#header-dep.headroom #dep-menu-share .dep-social-networks a:focus span,#header-dep.headroom #dep-menu-share .dep-social-networks a:hover span{-webkit-transition:all .3s;transition:all .3s;font-size:1.2em;line-height:1em}#header-dep.headroom button.dep-menu-share{position:relative;float:left;min-height:1px;padding-left:0;padding-right:0;width:3.75%;float:right;border:0;background:transparent;text-align:center;font-size:2.2em;color:#fff;height:3rem;margin-right:1rem}@media (max-width:991px){#header-dep.headroom button.dep-menu-share{width:7.5%}}#header-dep.headroom button.dep-menu-share .dep49-icon-arrow-down,#header-dep.headroom button.dep-menu-share .dep49-icon-arrow-up{display:none;position:absolute;font-size:.35em;right:-13%;top:20%;right:-60%}@media (min-width:544px){#header-dep.headroom button.dep-menu-share .dep49-icon-arrow-down,#header-dep.headroom button.dep-menu-share .dep49-icon-arrow-up{right:0}}#header-dep.headroom button.dep-menu-share[aria-expanded=true]:active .dep49-icon-arrow-up,#header-dep.headroom button.dep-menu-share[aria-expanded=true]:focus .dep49-icon-arrow-up,#header-dep.headroom button.dep-menu-share[aria-expanded=true]:hover .dep49-icon-arrow-up{display:block}#header-dep.headroom button.dep-menu-share[aria-expanded=false]:active .dep49-icon-arrow-up,#header-dep.headroom button.dep-menu-share[aria-expanded=false]:focus .dep49-icon-arrow-up,#header-dep.headroom button.dep-menu-share[aria-expanded=false]:hover .dep49-icon-arrow-up,#header-dep.headroom button.dep-menu-share[aria-expanded=true]:active .dep49-icon-arrow-down,#header-dep.headroom button.dep-menu-share[aria-expanded=true]:focus .dep49-icon-arrow-down,#header-dep.headroom button.dep-menu-share[aria-expanded=true]:hover .dep49-icon-arrow-down{display:none}#header-dep.headroom button.dep-menu-share[aria-expanded=false]:active .dep49-icon-arrow-down,#header-dep.headroom button.dep-menu-share[aria-expanded=false]:focus .dep49-icon-arrow-down,#header-dep.headroom button.dep-menu-share[aria-expanded=false]:hover .dep49-icon-arrow-down{display:block}#header-dep.headroom button.dep-menu-share:active,#header-dep.headroom button.dep-menu-share:focus,#header-dep.headroom button.dep-menu-share:hover{cursor:pointer}#header-dep.headroom .logo-anjou{float:left!important;width:10%;transition:all .4s ease-in-out;text-align:center;height:3rem;margin-left:1rem;font-size:2em}#header-dep.headroom .logo-anjou a:active,#header-dep.headroom .logo-anjou a:focus,#header-dep.headroom .logo-anjou a:hover{text-decoration:none}#header-dep.headroom .logo-anjou h1{font-size:1em;margin:0;border:0}#header-dep.headroom .logo-anjou span{display:block;color:#fff;font-size:5em;line-height:3rem;overflow:hidden}@media (min-width:992px){#header-dep.headroom .dep-navigation{transform:translateY(0);transition:all .25s ease-in-out;background:#444;margin-top:0;height:3rem;border-bottom:1px solid #ccc}#header-dep.headroom .dep-navigation .dropdown-menu{margin:0;padding:0;border-radius:0;border:0;background:#fff}#header-dep.headroom .dep-navigation .show>.dropdown-menu{display:block;box-shadow:0 10px 0 #e4e4e4}#header-dep.headroom .dep-navigation .subLevel0{background:#fff;font-size:1em;text-transform:none;padding:2rem 0 0;width:100%;font-family:Roboto,Arial,sans-serif}#header-dep.headroom .dep-navigation .subLevel0 .btn-fermer{text-align:right;text-transform:none;font-weight:400;font-family:Roboto,Arial,sans-serif;color:#4d4d4d!important;margin:0;font-size:.8em;padding-right:3rem!important;display:inline-block;margin-left:87%}#header-dep.headroom .dep-navigation .subLevel0 .btn-fermer .dep49-icon-close{background:#4d4d4d;color:#fff;padding:.5em;position:absolute;bottom:0;right:0}#header-dep.headroom .dep-navigation .subLevel0 .btn-fermer:active,#header-dep.headroom .dep-navigation .subLevel0 .btn-fermer:focus,#header-dep.headroom .dep-navigation .subLevel0 .btn-fermer:hover{text-decoration:underline}#header-dep.headroom .dep-navigation a,#header-dep.headroom .dep-navigation button{position:relative;display:inline-block;outline:none;text-decoration:none;color:#fff;padding-left:1rem;padding-right:1rem}#header-dep.headroom .dep-navigation a:before,#header-dep.headroom .dep-navigation button:before{position:absolute;top:0;left:0;width:100%;height:1px;content:\"\";opacity:0;-webkit-transition:height .3s,opacity .3s,-webkit-transform .3s;transition:height .3s,opacity .3s,transform .3s;-webkit-transform:translateY(10px);transform:translateY(10px)}#header-dep.headroom .dep-navigation a:focus:before,#header-dep.headroom .dep-navigation a:hover:before,#header-dep.headroom .dep-navigation button:focus:before,#header-dep.headroom .dep-navigation button:hover:before{height:5px;opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}#header-dep.headroom .dep-navigation ul.nav{text-transform:uppercase;color:#0c4e78;font-family:Century Gothic,Times New Roman,serif;font-weight:700;-js-display:flex;display:-webkit-box;display:-webkit-flexbox;display:-ms-flexbox;display:flex;padding-left:8rem;padding-right:8rem;position:relative;float:left;min-height:1px;padding-left:0;padding-right:0;justify-content:flex-start;width:65%;margin-left:2.5%;height:3rem;position:static}#header-dep.headroom .dep-navigation ul.nav>li,#header-dep.headroom .dep-navigation ul.nav>li>div{border-right:1px solid #ccc;-js-display:flex;display:-webkit-box;display:-webkit-flexbox;display:-ms-flexbox;display:flex;justify-content:space-between;align-items:stretch}#header-dep.headroom .dep-navigation ul.nav>li:first-of-type,#header-dep.headroom .dep-navigation ul.nav>li>div:first-of-type{border-left:1px solid #ccc}#header-dep.headroom .dep-navigation ul.nav>li:nth-of-type(4) :before,#header-dep.headroom .dep-navigation ul.nav>li>div:nth-of-type(4) :before{top:calc(100% + 11px);-webkit-transition:all .3s;transition:all .3s;-webkit-transform:translateY(-15px);transform:translateY(-15px)}#header-dep.headroom .dep-navigation ul.nav>li>a,#header-dep.headroom .dep-navigation ul.nav>li>div>a{color:#fff;line-height:2.8rem}#header-dep.headroom .dep-navigation ul.nav>li>a:before,#header-dep.headroom .dep-navigation ul.nav>li>div>a:before{background:#fff;height:3px}#header-dep.headroom .dep-navigation ul.nav>li:nth-of-type(4)>a:active:before,#header-dep.headroom .dep-navigation ul.nav>li:nth-of-type(4)>a:focus:before,#header-dep.headroom .dep-navigation ul.nav>li:nth-of-type(4)>a:hover:before{-webkit-transform:translateY(-15px);transform:translateY(-15px);height:4px;opacity:1}#header-dep.headroom .dep-navigation ul.nav.nav-inline .nav-item+.nav-item,#header-dep.headroom .dep-navigation ul.nav.nav-inline .nav-link+.nav-link{margin-left:0}#header-dep.headroom .dep-navigation ul.nav a,#header-dep.headroom .dep-navigation ul.nav button{font-size:1.3em}#header-dep.headroom .dep-navigation ul.nav li.open{border-top:4px solid #fff}#header-dep.headroom .dep-navigation ul.nav li.open a:active:before,#header-dep.headroom .dep-navigation ul.nav li.open a:focus:before,#header-dep.headroom .dep-navigation ul.nav li.open a:hover:before{display:none}#header-dep.headroom .dep-navigation ul.nav li:nth-of-type(4).open{border-top:0;border-bottom:4px solid #fff}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites.subLevel0 ul.active{border-right:0!important}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .subLevel2,#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .subLevel3{position:static;top:0;left:0}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .subLevel-title{display:none}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .hide{display:block}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites>.dropdown-item,#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites>a button.btn{text-transform:uppercase}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites div.dropdown-menu{width:100%}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .subLevel1{width:100%;margin:0;padding:0;display:flex}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .subLevel1>li{display:inline-block;padding-right:2em;width:19.6%;text-transform:uppercase;color:#af1d03;border-bottom:0;font-size:.9em}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep ul ul{margin:0;padding:0}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep ul li{border-bottom:0!important}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep ul li a{padding:.3em 0!important;font-size:100%;color:#0c4e78}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep ul li a:active,#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep ul li a:focus,#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep ul li a:hover{text-decoration:underline}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep ul li a:before{display:none;content:\"\"}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep ul>li ul li{text-transform:none;font-weight:400;list-style:none;margin-left:-25px}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep ul>li ul li a{color:#0c4e78}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep>ul>li{background:url(\"http://www.maine-et-loire.fr/fileadmin/dep49-header-footer/img/sites_dep1.png\") 0 2px no-repeat;padding-left:25px}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep>ul>li+li{background:url(\"http://www.maine-et-loire.fr/fileadmin/dep49-header-footer/img/sites_dep2.png\") 0 2px no-repeat;padding-left:25px}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep>ul>li+li+li{background:url(\"http://www.maine-et-loire.fr/fileadmin/dep49-header-footer/img/sites_dep3.png\") 0 2px no-repeat;padding-left:25px}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep>ul>li+li+li+li{background:url(\"http://www.maine-et-loire.fr/fileadmin/dep49-header-footer/img/sites_dep4.png\") 0 2px no-repeat;padding-left:25px}#header-dep.headroom .dep-navigation ul.nav #dep-autres-sites .sitesdep>ul>li+li+li+li+li{background:url(\"http://www.maine-et-loire.fr/fileadmin/dep49-header-footer/img/sites_dep5.png\") 0 2px no-repeat;padding-left:25px}}@media (min-width:768px) and (max-width:1199px){#header-dep.headroom .dep-navigation ul.nav{width:58.75%;margin-left:2.5%}}#header-dep.headroom .dep-navigation>.container{padding-left:0;padding-right:0}#header-dep.headroom #dep-menu-otherlinks{clear:both;position:relative;background-color:#444;overflow:auto}#header-dep.headroom #dep-menu-otherlinks ul{margin:0 20px}#header-dep.headroom #dep-menu-otherlinks ul.list-inline{position:relative}#header-dep.headroom #dep-menu-otherlinks ul ul{margin:0;padding:0}#header-dep.headroom #dep-menu-otherlinks a{text-decoration:none;color:#444;font-size:87.5%}#header-dep.headroom #dep-menu-otherlinks a:active,#header-dep.headroom #dep-menu-otherlinks a:focus,#header-dep.headroom #dep-menu-otherlinks a:hover{text-decoration:underline}#header-dep.headroom #dep-menu-otherlinks .sitesdep{clear:both;padding:20px 0;overflow:auto}#header-dep.headroom #dep-menu-otherlinks .sitesdep ul li{float:left;text-transform:uppercase;color:#444;font-size:81.3%;padding-left:25px;list-style:none}#header-dep.headroom #dep-menu-otherlinks .sitesdep ul li ul li{float:none;width:auto;text-transform:none;background:none!important;padding-left:0;font-size:100%}#header-dep.headroom ul{margin:0}@media (max-width:1199px){#header-dep.headroom .dep-menu-share,#header-dep.headroom .dep-navigation .dep-social-networks,#header-dep.headroom .dep-navigation ul.nav,#header-dep.headroom .dep-skip-navigation{display:none}#header-dep.headroom button.dep-menu-share{display:block}}.dep-credits{font-size:.7em;color:#333;background:#fff}.dep-credits .container{height:2rem;line-height:2rem;margin:auto}.dep-credits .nav{float:left;margin:0 1rem}.dep-credits .nav-item{display:inline-block}.dep-credits li:before{content:\"|\";padding:1em}.dep-credits li:before:first-of-type,.dep-credits li:first-of-type:before{display:none}.dep-credits .nav-inline .nav-item+.nav-item,.dep-credits .nav-inline .nav-link+.nav-link{margin-left:0}.dep-credits a{text-decoration:none;color:#333}.dep-credits a:active,.dep-credits a:hover{text-decoration:underline}.dep-credits p{right:1.2987%;float:right!important;margin:0 1rem}@media (max-width:991px){.dep-credits .container{height:auto}.dep-credits .nav{float:none;width:100%;text-align:center;font-size:1.2em}.dep-credits .nav-inline .nav-item{display:inline-block;padding:0 .3rem}.dep-credits li:before{padding:0 1em 0 0}.dep-credits p{right:0;float:none!important;margin-bottom:0;text-align:center;font-size:1em;line-height:1.5;padding:0 .5em .5em}}.footer-dep{overflow:hidden;clear:both;background:#444}.footer-dep .logo-anjou{position:relative;float:left;min-height:1px;padding-left:0;padding-right:0;width:15.58442%;margin-left:5.19481%}.footer-dep .dep-contact{background:#444;font-size:1.3em;color:#fff;padding-left:2rem}.footer-dep .dep-contact .container{margin:auto;-js-display:flex;display:-webkit-box;display:-webkit-flexbox;display:-ms-flexbox;display:flex;align-items:center;height:7rem}.footer-dep .dep-contact a{color:#fff;text-decoration:none;font-size:100%}.footer-dep .dep-contact a[href^=tel]{text-decoration:none}.footer-dep .dep-contact .icon-logo-anjou-footer{font-size:10rem;text-decoration:none;line-height:50%;display:block}.footer-dep .dep-contact p{margin:0;padding-left:1rem;padding-right:3rem;font-size:110%;line-height:1.3em}.footer-dep .dep-contact address{position:relative;float:left;min-height:1px;padding-left:0;padding-right:0;width:46.75325%;margin-left:5.19481%;border-left:1px solid #fff;-js-display:flex;display:-webkit-box;display:-webkit-flexbox;display:-ms-flexbox;display:flex;margin-bottom:0;line-height:130%;align-items:center;font-style:normal;font-family:Roboto,Arial,sans-serif}.footer-dep .dep-contact address p:first-of-type{border-right:1px solid #fff}.footer-dep .dep-contact address strong{font-weight:500;text-transform:uppercase;color:#fff!important}.footer-dep .dep-contact .dep-telephone span{display:block}.footer-dep a.btn{float:right!important;border-radius:0;background:#fff;text-transform:uppercase;font-weight:700;color:#333;font-family:Century Gothic,Times New Roman,serif;padding:1rem;margin-top:0;margin-right:5em;border:0;font-size:1.3em;cursor:pointer;text-align:center}.footer-dep a.btn:active,.footer-dep a.btn:focus,.footer-dep a.btn:hover{text-decoration:underline!important}@media (max-width:991px){.footer-dep .logo-anjou{width:100%;margin-left:0;margin-bottom:1em}.footer-dep .dep-contact{padding-left:0}.footer-dep .dep-contact .container{flex-direction:column;height:auto;padding:1rem}.footer-dep .dep-contact address{position:static;float:none;width:100%;margin-left:0;border-left:0;display:block;font-size:1em}.footer-dep .dep-contact address p{padding:.2em}.footer-dep .dep-contact address p:first-of-type{border-right:0}.footer-dep a.btn{font-size:1.3em;padding:.3em .5em;margin-right:0;margin-top:1rem}}@media (min-width:544px){.footer-dep .dep-contact .container{flex-direction:row}.footer-dep .dep-contact address{width:90%}}@media (min-width:544px) and (max-width:991px){.footer-dep .logo-anjou{width:60%}}", ""]);

// exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "@font-face{font-family:Century Gothic;src:url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/CenturyGothic.eot\");font-weight:400;font-style:normal}@font-face{font-family:Century Gothic;src:url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\"),url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/CenturyGothic.ttf\") format(\"truetype\");font-weight:400;font-style:normal}@font-face{font-family:Century Gothic;src:url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/CenturyGothic-Bold.eot\");font-weight:700;font-style:normal}@font-face{font-family:Century Gothic;src:url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\"),url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/CenturyGothic-Bold.ttf\") format(\"truetype\");font-weight:700;font-style:normal}", ""]);

// exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "@font-face{font-family:icomoon;src:url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/icomoon.eot?xz8qux\");src:url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/icomoon.eot?xz8qux#iefix\") format(\"embedded-opentype\"),url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/icomoon.ttf?xz8qux\") format(\"truetype\"),url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/icomoon.woff?xz8qux\") format(\"woff\"),url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/icomoon.svg?xz8qux#icomoon\") format(\"svg\");font-weight:400;font-style:normal}[class^=dep49-icon-]{font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.dep49-icon-facebook:before{content:\"\\E900\"}.dep49-icon-twitter:before{content:\"\\E901\"}.dep49-icon-flickr:before{content:\"\\E902\"}.dep49-icon-dailymotion:before{content:\"\\E903\"}.dep49-icon-accessibilite:before{content:\"\\E904\"}.dep49-icon-accessibilite2:before{content:\"\\E905\"}.dep49-icon-share:before{content:\"\\E906\"}.dep49-icon-instagram:before{content:\"\\E907\"}.dep49-icon-arrow-up:before{content:\"\\E908\"}.dep49-icon-arrow-down:before{content:\"\\E909\"}.dep49-icon-plus-circle:before{content:\"\\E90A\"}.dep49-icon-to-top:before{content:\"\\E90B\"}.dep49-icon-arrow:before{content:\"\\E90C\"}.dep49-icon-arrow-breadcrumb:before{content:\"\\E90D\"}.dep49-icon-collapse-down:before{content:\"\\E90E\"}.dep49-icon-collapse-up:before{content:\"\\E90F\"}.dep49-icon-search:before{content:\"\\E910\"}.dep49-icon-plus:before{content:\"\\E911\"}.dep49-icon-rss:before{content:\"\\E912\"}.dep49-icon-new-window:before{content:\"\\E913\"}.dep49-icon-close:before{content:\"\\E914\"}.dep49-icon-menu:before{content:\"\\E915\"}.dep49-icon-search-2:before{content:\"\\E916\"}.dep49-icon-marker:before{content:\"\\E917\"}.dep49-icon-alert:before{content:\"\\E918\"}.dep49-icon-lecture-facile:before{content:\"\\E919\"}.dep49-icon-print-pdf:before{content:\"\\E91A\"}.dep49-icon-tool:before{content:\"\\E91B\"}.dep49-icon-file-pdf:before{content:\"\\E91C\"}.dep49-icon-file-docx:before{content:\"\\E91D\"}.dep49-icon-file-xlsx:before{content:\"\\E91E\"}.dep49-icon-file-pptx:before{content:\"\\E91F\"}.dep49-icon-file-xxx:before{content:\"\\E920\"}.dep49-icon-logo-anjou:before{content:\"\\E921\"}.dep49-icon-youtube:before{content:\"\\E922\"}", ""]);

// exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "@font-face{font-family:OpenDyslexic\\ 3;src:url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/OpenDyslexicThree-Regular.eot\");font-weight:400;font-style:normal}@font-face{font-family:OpenDyslexic\\ 3;src:url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\"),url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/OpenDyslexicThree-Regular.ttf\") format(\"truetype\");font-weight:400;font-style:normal}@font-face{font-family:OpenDyslexic3;src:url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/OpenDyslexicThree-Bold.eot\");font-weight:700;font-style:normal}@font-face{font-family:OpenDyslexic3;src:url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\"),url(\"//www.maine-et-loire.fr/fileadmin/dep49-header-footer/fonts/OpenDyslexicThree-Bold.ttf\") format(\"truetype\");font-weight:700;font-style:normal}", ""]);

// exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ".collapse-enter-active[data-v-67b0a2de],.collapse-leave-active[data-v-67b0a2de]{transition:all .35s ease;overflow:hidden}.custom-file-control{overflow:hidden}.custom-file-control.dragging{overflow:hidden;filter:blur(3px)}.custom-file-control:after{content:attr(data-selected)}.custom-file-control:before{content:attr(data-choose)}.custom-file .drop-here{position:absolute;left:0;right:0;top:0;bottom:0;background-color:rgba(0,0,0,.5);border-radius:3px;z-index:99999;display:flex;justify-content:center;align-items:center}.custom-file .drop-here:before{color:#fff;content:attr(data-drop)}.hidden[data-v-1b4cbb68]{opacity:0!important}.modal[data-v-1b4cbb68]{display:block}.progress-bar{transition:all .5s}table>tfoot>tr>.sorting,table>thead>tr>.sorting{padding-right:30px;cursor:pointer;position:relative}table tfoot>tr>.sorting:before,table thead>tr>.sorting:after,table thead>tr>.sorting:before{position:absolute;bottom:.9em;display:block;opacity:.3}table.table-sm>tfoot>tr>.sorting:before,table.table-sm>thead>tr>.sorting:after,table.table-sm>thead>tr>.sorting:before{bottom:.4em}table>tfoot>tr>.sorting:before,table>thead>tr>.sorting:before{right:1em;content:\"\\2191\"}table>tfoot>tr>.sorting:after,table>thead>tr>.sorting:after{right:.5em;content:\"\\2193\"}table>tfoot>tr>.sorting_asc:before,table>tfoot>tr>.sorting_desc:after,table>thead>tr>.sorting_asc:before,table>thead>tr>.sorting_desc:after{opacity:1}.tooltip{display:block!important;transition:all .3s}", ""]);

// exports


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(18)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tether 1.4.3 */

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory(require, exports, module);
  } else {
    root.Tether = factory();
  }
}(this, function(require, exports, module) {

'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var TetherBase = undefined;
if (typeof TetherBase === 'undefined') {
  TetherBase = { modules: [] };
}

var zeroElement = null;

// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
// if the element lies within a nested document (<frame> or <iframe>-like).
function getActualBoundingClientRect(node) {
  var boundingRect = node.getBoundingClientRect();

  // The original object returned by getBoundingClientRect is immutable, so we clone it
  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
  var rect = {};
  for (var k in boundingRect) {
    rect[k] = boundingRect[k];
  }

  if (node.ownerDocument !== document) {
    var _frameElement = node.ownerDocument.defaultView.frameElement;
    if (_frameElement) {
      var frameRect = getActualBoundingClientRect(_frameElement);
      rect.top += frameRect.top;
      rect.bottom += frameRect.top;
      rect.left += frameRect.left;
      rect.right += frameRect.left;
    }
  }

  return rect;
}

function getScrollParents(el) {
  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  var computedStyle = getComputedStyle(el) || {};
  var position = computedStyle.position;
  var parents = [];

  if (position === 'fixed') {
    return [el];
  }

  var parent = el;
  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
    var style = undefined;
    try {
      style = getComputedStyle(parent);
    } catch (err) {}

    if (typeof style === 'undefined' || style === null) {
      parents.push(parent);
      return parents;
    }

    var _style = style;
    var overflow = _style.overflow;
    var overflowX = _style.overflowX;
    var overflowY = _style.overflowY;

    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
        parents.push(parent);
      }
    }
  }

  parents.push(el.ownerDocument.body);

  // If the node is within a frame, account for the parent window scroll
  if (el.ownerDocument !== document) {
    parents.push(el.ownerDocument.defaultView);
  }

  return parents;
}

var uniqueId = (function () {
  var id = 0;
  return function () {
    return ++id;
  };
})();

var zeroPosCache = {};
var getOrigin = function getOrigin() {
  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
  // jitter as the user scrolls that messes with our ability to detect if two positions
  // are equivilant or not.  We place an element at the top left of the page that will
  // get the same jitter, so we can cancel the two out.
  var node = zeroElement;
  if (!node || !document.body.contains(node)) {
    node = document.createElement('div');
    node.setAttribute('data-tether-id', uniqueId());
    extend(node.style, {
      top: 0,
      left: 0,
      position: 'absolute'
    });

    document.body.appendChild(node);

    zeroElement = node;
  }

  var id = node.getAttribute('data-tether-id');
  if (typeof zeroPosCache[id] === 'undefined') {
    zeroPosCache[id] = getActualBoundingClientRect(node);

    // Clear the cache when this position call is done
    defer(function () {
      delete zeroPosCache[id];
    });
  }

  return zeroPosCache[id];
};

function removeUtilElements() {
  if (zeroElement) {
    document.body.removeChild(zeroElement);
  }
  zeroElement = null;
};

function getBounds(el) {
  var doc = undefined;
  if (el === document) {
    doc = document;
    el = document.documentElement;
  } else {
    doc = el.ownerDocument;
  }

  var docEl = doc.documentElement;

  var box = getActualBoundingClientRect(el);

  var origin = getOrigin();

  box.top -= origin.top;
  box.left -= origin.left;

  if (typeof box.width === 'undefined') {
    box.width = document.body.scrollWidth - box.left - box.right;
  }
  if (typeof box.height === 'undefined') {
    box.height = document.body.scrollHeight - box.top - box.bottom;
  }

  box.top = box.top - docEl.clientTop;
  box.left = box.left - docEl.clientLeft;
  box.right = doc.body.clientWidth - box.width - box.left;
  box.bottom = doc.body.clientHeight - box.height - box.top;

  return box;
}

function getOffsetParent(el) {
  return el.offsetParent || document.documentElement;
}

var _scrollBarSize = null;
function getScrollBarSize() {
  if (_scrollBarSize) {
    return _scrollBarSize;
  }
  var inner = document.createElement('div');
  inner.style.width = '100%';
  inner.style.height = '200px';

  var outer = document.createElement('div');
  extend(outer.style, {
    position: 'absolute',
    top: 0,
    left: 0,
    pointerEvents: 'none',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  });

  outer.appendChild(inner);

  document.body.appendChild(outer);

  var widthContained = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var widthScroll = inner.offsetWidth;

  if (widthContained === widthScroll) {
    widthScroll = outer.clientWidth;
  }

  document.body.removeChild(outer);

  var width = widthContained - widthScroll;

  _scrollBarSize = { width: width, height: width };
  return _scrollBarSize;
}

function extend() {
  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var args = [];

  Array.prototype.push.apply(args, arguments);

  args.slice(1).forEach(function (obj) {
    if (obj) {
      for (var key in obj) {
        if (({}).hasOwnProperty.call(obj, key)) {
          out[key] = obj[key];
        }
      }
    }
  });

  return out;
}

function removeClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.remove(cls);
      }
    });
  } else {
    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
    var className = getClassName(el).replace(regex, ' ');
    setClassName(el, className);
  }
}

function addClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.add(cls);
      }
    });
  } else {
    removeClass(el, name);
    var cls = getClassName(el) + (' ' + name);
    setClassName(el, cls);
  }
}

function hasClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    return el.classList.contains(name);
  }
  var className = getClassName(el);
  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
}

function getClassName(el) {
  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
  // completely separately SVGAnimatedString base classes
  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
    return el.className.baseVal;
  }
  return el.className;
}

function setClassName(el, className) {
  el.setAttribute('class', className);
}

function updateClasses(el, add, all) {
  // Of the set of 'all' classes, we need the 'add' classes, and only the
  // 'add' classes to be set.
  all.forEach(function (cls) {
    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
      removeClass(el, cls);
    }
  });

  add.forEach(function (cls) {
    if (!hasClass(el, cls)) {
      addClass(el, cls);
    }
  });
}

var deferred = [];

var defer = function defer(fn) {
  deferred.push(fn);
};

var flush = function flush() {
  var fn = undefined;
  while (fn = deferred.pop()) {
    fn();
  }
};

var Evented = (function () {
  function Evented() {
    _classCallCheck(this, Evented);
  }

  _createClass(Evented, [{
    key: 'on',
    value: function on(event, handler, ctx) {
      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

      if (typeof this.bindings === 'undefined') {
        this.bindings = {};
      }
      if (typeof this.bindings[event] === 'undefined') {
        this.bindings[event] = [];
      }
      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
    }
  }, {
    key: 'once',
    value: function once(event, handler, ctx) {
      this.on(event, handler, ctx, true);
    }
  }, {
    key: 'off',
    value: function off(event, handler) {
      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
        return;
      }

      if (typeof handler === 'undefined') {
        delete this.bindings[event];
      } else {
        var i = 0;
        while (i < this.bindings[event].length) {
          if (this.bindings[event][i].handler === handler) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(event) {
      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
        var i = 0;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        while (i < this.bindings[event].length) {
          var _bindings$event$i = this.bindings[event][i];
          var handler = _bindings$event$i.handler;
          var ctx = _bindings$event$i.ctx;
          var once = _bindings$event$i.once;

          var context = ctx;
          if (typeof context === 'undefined') {
            context = this;
          }

          handler.apply(context, args);

          if (once) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }]);

  return Evented;
})();

TetherBase.Utils = {
  getActualBoundingClientRect: getActualBoundingClientRect,
  getScrollParents: getScrollParents,
  getBounds: getBounds,
  getOffsetParent: getOffsetParent,
  extend: extend,
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  updateClasses: updateClasses,
  defer: defer,
  flush: flush,
  uniqueId: uniqueId,
  Evented: Evented,
  getScrollBarSize: getScrollBarSize,
  removeUtilElements: removeUtilElements
};
/* globals TetherBase, performance */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (typeof TetherBase === 'undefined') {
  throw new Error('You must include the utils.js file before tether.js');
}

var _TetherBase$Utils = TetherBase.Utils;
var getScrollParents = _TetherBase$Utils.getScrollParents;
var getBounds = _TetherBase$Utils.getBounds;
var getOffsetParent = _TetherBase$Utils.getOffsetParent;
var extend = _TetherBase$Utils.extend;
var addClass = _TetherBase$Utils.addClass;
var removeClass = _TetherBase$Utils.removeClass;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;
var flush = _TetherBase$Utils.flush;
var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
var removeUtilElements = _TetherBase$Utils.removeUtilElements;

function within(a, b) {
  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];

  return a + diff >= b && b >= a - diff;
}

var transformKey = (function () {
  if (typeof document === 'undefined') {
    return '';
  }
  var el = document.createElement('div');

  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
  for (var i = 0; i < transforms.length; ++i) {
    var key = transforms[i];
    if (el.style[key] !== undefined) {
      return key;
    }
  }
})();

var tethers = [];

var position = function position() {
  tethers.forEach(function (tether) {
    tether.position(false);
  });
  flush();
};

function now() {
  if (typeof performance === 'object' && typeof performance.now === 'function') {
    return performance.now();
  }
  return +new Date();
}

(function () {
  var lastCall = null;
  var lastDuration = null;
  var pendingTimeout = null;

  var tick = function tick() {
    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
      // We voluntarily throttle ourselves if we can't manage 60fps
      lastDuration = Math.min(lastDuration - 16, 250);

      // Just in case this is the last event, remember to position just once more
      pendingTimeout = setTimeout(tick, 250);
      return;
    }

    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
      // Some browsers call events a little too frequently, refuse to run more than is reasonable
      return;
    }

    if (pendingTimeout != null) {
      clearTimeout(pendingTimeout);
      pendingTimeout = null;
    }

    lastCall = now();
    position();
    lastDuration = now() - lastCall;
  };

  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
      window.addEventListener(event, tick);
    });
  }
})();

var MIRROR_LR = {
  center: 'center',
  left: 'right',
  right: 'left'
};

var MIRROR_TB = {
  middle: 'middle',
  top: 'bottom',
  bottom: 'top'
};

var OFFSET_MAP = {
  top: 0,
  left: 0,
  middle: '50%',
  center: '50%',
  bottom: '100%',
  right: '100%'
};

var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (left === 'auto') {
    left = MIRROR_LR[relativeToAttachment.left];
  }

  if (top === 'auto') {
    top = MIRROR_TB[relativeToAttachment.top];
  }

  return { left: left, top: top };
};

var attachmentToOffset = function attachmentToOffset(attachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
    left = OFFSET_MAP[attachment.left];
  }

  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
    top = OFFSET_MAP[attachment.top];
  }

  return { left: left, top: top };
};

function addOffset() {
  var out = { top: 0, left: 0 };

  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
    offsets[_key] = arguments[_key];
  }

  offsets.forEach(function (_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (typeof top === 'string') {
      top = parseFloat(top, 10);
    }
    if (typeof left === 'string') {
      left = parseFloat(left, 10);
    }

    out.top += top;
    out.left += left;
  });

  return out;
}

function offsetToPx(offset, size) {
  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
  }
  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
  }

  return offset;
}

var parseOffset = function parseOffset(value) {
  var _value$split = value.split(' ');

  var _value$split2 = _slicedToArray(_value$split, 2);

  var top = _value$split2[0];
  var left = _value$split2[1];

  return { top: top, left: left };
};
var parseAttachment = parseOffset;

var TetherClass = (function (_Evented) {
  _inherits(TetherClass, _Evented);

  function TetherClass(options) {
    var _this = this;

    _classCallCheck(this, TetherClass);

    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
    this.position = this.position.bind(this);

    tethers.push(this);

    this.history = [];

    this.setOptions(options, false);

    TetherBase.modules.forEach(function (module) {
      if (typeof module.initialize !== 'undefined') {
        module.initialize.call(_this);
      }
    });

    this.position();
  }

  _createClass(TetherClass, [{
    key: 'getClass',
    value: function getClass() {
      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
      var classes = this.options.classes;

      if (typeof classes !== 'undefined' && classes[key]) {
        return this.options.classes[key];
      } else if (this.options.classPrefix) {
        return this.options.classPrefix + '-' + key;
      } else {
        return key;
      }
    }
  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      var _this2 = this;

      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

      var defaults = {
        offset: '0 0',
        targetOffset: '0 0',
        targetAttachment: 'auto auto',
        classPrefix: 'tether'
      };

      this.options = extend(defaults, options);

      var _options = this.options;
      var element = _options.element;
      var target = _options.target;
      var targetModifier = _options.targetModifier;

      this.element = element;
      this.target = target;
      this.targetModifier = targetModifier;

      if (this.target === 'viewport') {
        this.target = document.body;
        this.targetModifier = 'visible';
      } else if (this.target === 'scroll-handle') {
        this.target = document.body;
        this.targetModifier = 'scroll-handle';
      }

      ['element', 'target'].forEach(function (key) {
        if (typeof _this2[key] === 'undefined') {
          throw new Error('Tether Error: Both element and target must be defined');
        }

        if (typeof _this2[key].jquery !== 'undefined') {
          _this2[key] = _this2[key][0];
        } else if (typeof _this2[key] === 'string') {
          _this2[key] = document.querySelector(_this2[key]);
        }
      });

      addClass(this.element, this.getClass('element'));
      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('target'));
      }

      if (!this.options.attachment) {
        throw new Error('Tether Error: You must provide an attachment');
      }

      this.targetAttachment = parseAttachment(this.options.targetAttachment);
      this.attachment = parseAttachment(this.options.attachment);
      this.offset = parseOffset(this.options.offset);
      this.targetOffset = parseOffset(this.options.targetOffset);

      if (typeof this.scrollParents !== 'undefined') {
        this.disable();
      }

      if (this.targetModifier === 'scroll-handle') {
        this.scrollParents = [this.target];
      } else {
        this.scrollParents = getScrollParents(this.target);
      }

      if (!(this.options.enabled === false)) {
        this.enable(pos);
      }
    }
  }, {
    key: 'getTargetBounds',
    value: function getTargetBounds() {
      if (typeof this.targetModifier !== 'undefined') {
        if (this.targetModifier === 'visible') {
          if (this.target === document.body) {
            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
          } else {
            var bounds = getBounds(this.target);

            var out = {
              height: bounds.height,
              width: bounds.width,
              top: bounds.top,
              left: bounds.left
            };

            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
            out.height = Math.min(innerHeight, out.height);
            out.height -= 2;

            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
            out.width = Math.min(innerWidth, out.width);
            out.width -= 2;

            if (out.top < pageYOffset) {
              out.top = pageYOffset;
            }
            if (out.left < pageXOffset) {
              out.left = pageXOffset;
            }

            return out;
          }
        } else if (this.targetModifier === 'scroll-handle') {
          var bounds = undefined;
          var target = this.target;
          if (target === document.body) {
            target = document.documentElement;

            bounds = {
              left: pageXOffset,
              top: pageYOffset,
              height: innerHeight,
              width: innerWidth
            };
          } else {
            bounds = getBounds(target);
          }

          var style = getComputedStyle(target);

          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;

          var scrollBottom = 0;
          if (hasBottomScroll) {
            scrollBottom = 15;
          }

          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;

          var out = {
            width: 15,
            height: height * 0.975 * (height / target.scrollHeight),
            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
          };

          var fitAdj = 0;
          if (height < 408 && this.target === document.body) {
            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
          }

          if (this.target !== document.body) {
            out.height = Math.max(out.height, 24);
          }

          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);

          if (this.target === document.body) {
            out.height = Math.max(out.height, 24);
          }

          return out;
        }
      } else {
        return getBounds(this.target);
      }
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      this._cache = {};
    }
  }, {
    key: 'cache',
    value: function cache(k, getter) {
      // More than one module will often need the same DOM info, so
      // we keep a cache which is cleared on each position call
      if (typeof this._cache === 'undefined') {
        this._cache = {};
      }

      if (typeof this._cache[k] === 'undefined') {
        this._cache[k] = getter.call(this);
      }

      return this._cache[k];
    }
  }, {
    key: 'enable',
    value: function enable() {
      var _this3 = this;

      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('enabled'));
      }
      addClass(this.element, this.getClass('enabled'));
      this.enabled = true;

      this.scrollParents.forEach(function (parent) {
        if (parent !== _this3.target.ownerDocument) {
          parent.addEventListener('scroll', _this3.position);
        }
      });

      if (pos) {
        this.position();
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      var _this4 = this;

      removeClass(this.target, this.getClass('enabled'));
      removeClass(this.element, this.getClass('enabled'));
      this.enabled = false;

      if (typeof this.scrollParents !== 'undefined') {
        this.scrollParents.forEach(function (parent) {
          parent.removeEventListener('scroll', _this4.position);
        });
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this5 = this;

      this.disable();

      tethers.forEach(function (tether, i) {
        if (tether === _this5) {
          tethers.splice(i, 1);
        }
      });

      // Remove any elements we were using for convenience from the DOM
      if (tethers.length === 0) {
        removeUtilElements();
      }
    }
  }, {
    key: 'updateAttachClasses',
    value: function updateAttachClasses(elementAttach, targetAttach) {
      var _this6 = this;

      elementAttach = elementAttach || this.attachment;
      targetAttach = targetAttach || this.targetAttachment;
      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];

      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
        // updateAttachClasses can be called more than once in a position call, so
        // we need to clean up after ourselves such that when the last defer gets
        // ran it doesn't add any extra classes from previous calls.
        this._addAttachClasses.splice(0, this._addAttachClasses.length);
      }

      if (typeof this._addAttachClasses === 'undefined') {
        this._addAttachClasses = [];
      }
      var add = this._addAttachClasses;

      if (elementAttach.top) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.top);
      }
      if (elementAttach.left) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.left);
      }
      if (targetAttach.top) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.top);
      }
      if (targetAttach.left) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.left);
      }

      var all = [];
      sides.forEach(function (side) {
        all.push(_this6.getClass('element-attached') + '-' + side);
        all.push(_this6.getClass('target-attached') + '-' + side);
      });

      defer(function () {
        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
          return;
        }

        updateClasses(_this6.element, _this6._addAttachClasses, all);
        if (!(_this6.options.addTargetClasses === false)) {
          updateClasses(_this6.target, _this6._addAttachClasses, all);
        }

        delete _this6._addAttachClasses;
      });
    }
  }, {
    key: 'position',
    value: function position() {
      var _this7 = this;

      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
      // tethers (in which case call Tether.Utils.flush yourself when you're done)

      if (!this.enabled) {
        return;
      }

      this.clearCache();

      // Turn 'auto' attachments into the appropriate corner or edge
      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);

      this.updateAttachClasses(this.attachment, targetAttachment);

      var elementPos = this.cache('element-bounds', function () {
        return getBounds(_this7.element);
      });

      var width = elementPos.width;
      var height = elementPos.height;

      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
        var _lastSize = this.lastSize;

        // We cache the height and width to make it possible to position elements that are
        // getting hidden.
        width = _lastSize.width;
        height = _lastSize.height;
      } else {
        this.lastSize = { width: width, height: height };
      }

      var targetPos = this.cache('target-bounds', function () {
        return _this7.getTargetBounds();
      });
      var targetSize = targetPos;

      // Get an actual px offset from the attachment
      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);

      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);

      // Add the manually provided offset
      offset = addOffset(offset, manualOffset);
      targetOffset = addOffset(targetOffset, manualTargetOffset);

      // It's now our goal to make (element position + offset) == (target position + target offset)
      var left = targetPos.left + targetOffset.left - offset.left;
      var top = targetPos.top + targetOffset.top - offset.top;

      for (var i = 0; i < TetherBase.modules.length; ++i) {
        var _module2 = TetherBase.modules[i];
        var ret = _module2.position.call(this, {
          left: left,
          top: top,
          targetAttachment: targetAttachment,
          targetPos: targetPos,
          elementPos: elementPos,
          offset: offset,
          targetOffset: targetOffset,
          manualOffset: manualOffset,
          manualTargetOffset: manualTargetOffset,
          scrollbarSize: scrollbarSize,
          attachment: this.attachment
        });

        if (ret === false) {
          return false;
        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
          continue;
        } else {
          top = ret.top;
          left = ret.left;
        }
      }

      // We describe the position three different ways to give the optimizer
      // a chance to decide the best possible way to position the element
      // with the fewest repaints.
      var next = {
        // It's position relative to the page (absolute positioning when
        // the element is a child of the body)
        page: {
          top: top,
          left: left
        },

        // It's position relative to the viewport (fixed positioning)
        viewport: {
          top: top - pageYOffset,
          bottom: pageYOffset - top - height + innerHeight,
          left: left - pageXOffset,
          right: pageXOffset - left - width + innerWidth
        }
      };

      var doc = this.target.ownerDocument;
      var win = doc.defaultView;

      var scrollbarSize = undefined;
      if (win.innerHeight > doc.documentElement.clientHeight) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.bottom -= scrollbarSize.height;
      }

      if (win.innerWidth > doc.documentElement.clientWidth) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.right -= scrollbarSize.width;
      }

      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
        next.page.bottom = doc.body.scrollHeight - top - height;
        next.page.right = doc.body.scrollWidth - left - width;
      }

      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
        (function () {
          var offsetParent = _this7.cache('target-offsetparent', function () {
            return getOffsetParent(_this7.target);
          });
          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
            return getBounds(offsetParent);
          });
          var offsetParentStyle = getComputedStyle(offsetParent);
          var offsetParentSize = offsetPosition;

          var offsetBorder = {};
          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
          });

          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;

          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
              // We're within the visible part of the target's scroll parent
              var scrollTop = offsetParent.scrollTop;
              var scrollLeft = offsetParent.scrollLeft;

              // It's position relative to the target's offset parent (absolute positioning when
              // the element is moved to be a child of the target's offset parent).
              next.offset = {
                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
              };
            }
          }
        })();
      }

      // We could also travel up the DOM and try each containing context, rather than only
      // looking at the body, but we're gonna get diminishing returns.

      this.move(next);

      this.history.unshift(next);

      if (this.history.length > 3) {
        this.history.pop();
      }

      if (flushChanges) {
        flush();
      }

      return true;
    }

    // THE ISSUE
  }, {
    key: 'move',
    value: function move(pos) {
      var _this8 = this;

      if (!(typeof this.element.parentNode !== 'undefined')) {
        return;
      }

      var same = {};

      for (var type in pos) {
        same[type] = {};

        for (var key in pos[type]) {
          var found = false;

          for (var i = 0; i < this.history.length; ++i) {
            var point = this.history[i];
            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
              found = true;
              break;
            }
          }

          if (!found) {
            same[type][key] = true;
          }
        }
      }

      var css = { top: '', left: '', right: '', bottom: '' };

      var transcribe = function transcribe(_same, _pos) {
        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
        if (gpu !== false) {
          var yPos = undefined,
              xPos = undefined;
          if (_same.top) {
            css.top = 0;
            yPos = _pos.top;
          } else {
            css.bottom = 0;
            yPos = -_pos.bottom;
          }

          if (_same.left) {
            css.left = 0;
            xPos = _pos.left;
          } else {
            css.right = 0;
            xPos = -_pos.right;
          }

          if (window.matchMedia) {
            // HubSpot/tether#207
            var retina = window.matchMedia('only screen and (min-resolution: 1.3dppx)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3)').matches;
            if (!retina) {
              xPos = Math.round(xPos);
              yPos = Math.round(yPos);
            }
          }

          css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';

          if (transformKey !== 'msTransform') {
            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
            // but IE9 doesn't support 3d transforms and will choke.
            css[transformKey] += " translateZ(0)";
          }
        } else {
          if (_same.top) {
            css.top = _pos.top + 'px';
          } else {
            css.bottom = _pos.bottom + 'px';
          }

          if (_same.left) {
            css.left = _pos.left + 'px';
          } else {
            css.right = _pos.right + 'px';
          }
        }
      };

      var moved = false;
      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
        css.position = 'absolute';
        transcribe(same.page, pos.page);
      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
        css.position = 'fixed';
        transcribe(same.viewport, pos.viewport);
      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
        (function () {
          css.position = 'absolute';
          var offsetParent = _this8.cache('target-offsetparent', function () {
            return getOffsetParent(_this8.target);
          });

          if (getOffsetParent(_this8.element) !== offsetParent) {
            defer(function () {
              _this8.element.parentNode.removeChild(_this8.element);
              offsetParent.appendChild(_this8.element);
            });
          }

          transcribe(same.offset, pos.offset);
          moved = true;
        })();
      } else {
        css.position = 'absolute';
        transcribe({ top: true, left: true }, pos.page);
      }

      if (!moved) {
        if (this.options.bodyElement) {
          if (this.element.parentNode !== this.options.bodyElement) {
            this.options.bodyElement.appendChild(this.element);
          }
        } else {
          var offsetParentIsBody = true;
          var currentNode = this.element.parentNode;
          while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY') {
            if (getComputedStyle(currentNode).position !== 'static') {
              offsetParentIsBody = false;
              break;
            }

            currentNode = currentNode.parentNode;
          }

          if (!offsetParentIsBody) {
            this.element.parentNode.removeChild(this.element);
            this.element.ownerDocument.body.appendChild(this.element);
          }
        }
      }

      // Any css change will trigger a repaint, so let's avoid one if nothing changed
      var writeCSS = {};
      var write = false;
      for (var key in css) {
        var val = css[key];
        var elVal = this.element.style[key];

        if (elVal !== val) {
          write = true;
          writeCSS[key] = val;
        }
      }

      if (write) {
        defer(function () {
          extend(_this8.element.style, writeCSS);
          _this8.trigger('repositioned');
        });
      }
    }
  }]);

  return TetherClass;
})(Evented);

TetherClass.modules = [];

TetherBase.position = position;

var Tether = extend(TetherClass, TetherBase);
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var extend = _TetherBase$Utils.extend;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];

function getBoundingRect(tether, to) {
  if (to === 'scrollParent') {
    to = tether.scrollParents[0];
  } else if (to === 'window') {
    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
  }

  if (to === document) {
    to = to.documentElement;
  }

  if (typeof to.nodeType !== 'undefined') {
    (function () {
      var node = to;
      var size = getBounds(to);
      var pos = size;
      var style = getComputedStyle(to);

      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];

      // Account any parent Frames scroll offset
      if (node.ownerDocument !== document) {
        var win = node.ownerDocument.defaultView;
        to[0] += win.pageXOffset;
        to[1] += win.pageYOffset;
        to[2] += win.pageXOffset;
        to[3] += win.pageYOffset;
      }

      BOUNDS_FORMAT.forEach(function (side, i) {
        side = side[0].toUpperCase() + side.substr(1);
        if (side === 'Top' || side === 'Left') {
          to[i] += parseFloat(style['border' + side + 'Width']);
        } else {
          to[i] -= parseFloat(style['border' + side + 'Width']);
        }
      });
    })();
  }

  return to;
}

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;
    var targetAttachment = _ref.targetAttachment;

    if (!this.options.constraints) {
      return true;
    }

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
      var _lastSize = this.lastSize;

      // Handle the item getting hidden as a result of our positioning without glitching
      // the classes in and out
      width = _lastSize.width;
      height = _lastSize.height;
    }

    var targetSize = this.cache('target-bounds', function () {
      return _this.getTargetBounds();
    });

    var targetHeight = targetSize.height;
    var targetWidth = targetSize.width;

    var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];

    this.options.constraints.forEach(function (constraint) {
      var outOfBoundsClass = constraint.outOfBoundsClass;
      var pinnedClass = constraint.pinnedClass;

      if (outOfBoundsClass) {
        allClasses.push(outOfBoundsClass);
      }
      if (pinnedClass) {
        allClasses.push(pinnedClass);
      }
    });

    allClasses.forEach(function (cls) {
      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
        allClasses.push(cls + '-' + side);
      });
    });

    var addClasses = [];

    var tAttachment = extend({}, targetAttachment);
    var eAttachment = extend({}, this.attachment);

    this.options.constraints.forEach(function (constraint) {
      var to = constraint.to;
      var attachment = constraint.attachment;
      var pin = constraint.pin;

      if (typeof attachment === 'undefined') {
        attachment = '';
      }

      var changeAttachX = undefined,
          changeAttachY = undefined;
      if (attachment.indexOf(' ') >= 0) {
        var _attachment$split = attachment.split(' ');

        var _attachment$split2 = _slicedToArray(_attachment$split, 2);

        changeAttachY = _attachment$split2[0];
        changeAttachX = _attachment$split2[1];
      } else {
        changeAttachX = changeAttachY = attachment;
      }

      var bounds = getBoundingRect(_this, to);

      if (changeAttachY === 'target' || changeAttachY === 'both') {
        if (top < bounds[1] && tAttachment.top === 'top') {
          top += targetHeight;
          tAttachment.top = 'bottom';
        }

        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
          top -= targetHeight;
          tAttachment.top = 'top';
        }
      }

      if (changeAttachY === 'together') {
        if (tAttachment.top === 'top') {
          if (eAttachment.top === 'bottom' && top < bounds[1]) {
            top += targetHeight;
            tAttachment.top = 'bottom';

            top += height;
            eAttachment.top = 'top';
          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
            top -= height - targetHeight;
            tAttachment.top = 'bottom';

            eAttachment.top = 'bottom';
          }
        }

        if (tAttachment.top === 'bottom') {
          if (eAttachment.top === 'top' && top + height > bounds[3]) {
            top -= targetHeight;
            tAttachment.top = 'top';

            top -= height;
            eAttachment.top = 'bottom';
          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
            top += height - targetHeight;
            tAttachment.top = 'top';

            eAttachment.top = 'top';
          }
        }

        if (tAttachment.top === 'middle') {
          if (top + height > bounds[3] && eAttachment.top === 'top') {
            top -= height;
            eAttachment.top = 'bottom';
          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
            top += height;
            eAttachment.top = 'top';
          }
        }
      }

      if (changeAttachX === 'target' || changeAttachX === 'both') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          left += targetWidth;
          tAttachment.left = 'right';
        }

        if (left + width > bounds[2] && tAttachment.left === 'right') {
          left -= targetWidth;
          tAttachment.left = 'left';
        }
      }

      if (changeAttachX === 'together') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          if (eAttachment.left === 'right') {
            left += targetWidth;
            tAttachment.left = 'right';

            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'left') {
            left += targetWidth;
            tAttachment.left = 'right';

            left -= width;
            eAttachment.left = 'right';
          }
        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
          if (eAttachment.left === 'left') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'right') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left += width;
            eAttachment.left = 'left';
          }
        } else if (tAttachment.left === 'center') {
          if (left + width > bounds[2] && eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (left < bounds[0] && eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          }
        }
      }

      if (changeAttachY === 'element' || changeAttachY === 'both') {
        if (top < bounds[1] && eAttachment.top === 'bottom') {
          top += height;
          eAttachment.top = 'top';
        }

        if (top + height > bounds[3] && eAttachment.top === 'top') {
          top -= height;
          eAttachment.top = 'bottom';
        }
      }

      if (changeAttachX === 'element' || changeAttachX === 'both') {
        if (left < bounds[0]) {
          if (eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'center') {
            left += width / 2;
            eAttachment.left = 'left';
          }
        }

        if (left + width > bounds[2]) {
          if (eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'center') {
            left -= width / 2;
            eAttachment.left = 'right';
          }
        }
      }

      if (typeof pin === 'string') {
        pin = pin.split(',').map(function (p) {
          return p.trim();
        });
      } else if (pin === true) {
        pin = ['top', 'left', 'right', 'bottom'];
      }

      pin = pin || [];

      var pinned = [];
      var oob = [];

      if (top < bounds[1]) {
        if (pin.indexOf('top') >= 0) {
          top = bounds[1];
          pinned.push('top');
        } else {
          oob.push('top');
        }
      }

      if (top + height > bounds[3]) {
        if (pin.indexOf('bottom') >= 0) {
          top = bounds[3] - height;
          pinned.push('bottom');
        } else {
          oob.push('bottom');
        }
      }

      if (left < bounds[0]) {
        if (pin.indexOf('left') >= 0) {
          left = bounds[0];
          pinned.push('left');
        } else {
          oob.push('left');
        }
      }

      if (left + width > bounds[2]) {
        if (pin.indexOf('right') >= 0) {
          left = bounds[2] - width;
          pinned.push('right');
        } else {
          oob.push('right');
        }
      }

      if (pinned.length) {
        (function () {
          var pinnedClass = undefined;
          if (typeof _this.options.pinnedClass !== 'undefined') {
            pinnedClass = _this.options.pinnedClass;
          } else {
            pinnedClass = _this.getClass('pinned');
          }

          addClasses.push(pinnedClass);
          pinned.forEach(function (side) {
            addClasses.push(pinnedClass + '-' + side);
          });
        })();
      }

      if (oob.length) {
        (function () {
          var oobClass = undefined;
          if (typeof _this.options.outOfBoundsClass !== 'undefined') {
            oobClass = _this.options.outOfBoundsClass;
          } else {
            oobClass = _this.getClass('out-of-bounds');
          }

          addClasses.push(oobClass);
          oob.forEach(function (side) {
            addClasses.push(oobClass + '-' + side);
          });
        })();
      }

      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
        eAttachment.left = tAttachment.left = false;
      }
      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
        eAttachment.top = tAttachment.top = false;
      }

      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
        _this.updateAttachClasses(eAttachment, tAttachment);
        _this.trigger('update', {
          attachment: eAttachment,
          targetAttachment: tAttachment
        });
      }
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return { top: top, left: left };
  }
});
/* globals TetherBase */

'use strict';

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    var targetPos = this.getTargetBounds();

    var bottom = top + height;
    var right = left + width;

    var abutted = [];
    if (top <= targetPos.bottom && bottom >= targetPos.top) {
      ['left', 'right'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === left || targetPosSide === right) {
          abutted.push(side);
        }
      });
    }

    if (left <= targetPos.right && right >= targetPos.left) {
      ['top', 'bottom'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === top || targetPosSide === bottom) {
          abutted.push(side);
        }
      });
    }

    var allClasses = [];
    var addClasses = [];

    var sides = ['left', 'top', 'right', 'bottom'];
    allClasses.push(this.getClass('abutted'));
    sides.forEach(function (side) {
      allClasses.push(_this.getClass('abutted') + '-' + side);
    });

    if (abutted.length) {
      addClasses.push(this.getClass('abutted'));
    }

    abutted.forEach(function (side) {
      addClasses.push(_this.getClass('abutted') + '-' + side);
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return true;
  }
});
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

TetherBase.modules.push({
  position: function position(_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (!this.options.shift) {
      return;
    }

    var shift = this.options.shift;
    if (typeof this.options.shift === 'function') {
      shift = this.options.shift.call(this, { top: top, left: left });
    }

    var shiftTop = undefined,
        shiftLeft = undefined;
    if (typeof shift === 'string') {
      shift = shift.split(' ');
      shift[1] = shift[1] || shift[0];

      var _shift = shift;

      var _shift2 = _slicedToArray(_shift, 2);

      shiftTop = _shift2[0];
      shiftLeft = _shift2[1];

      shiftTop = parseFloat(shiftTop, 10);
      shiftLeft = parseFloat(shiftLeft, 10);
    } else {
      shiftTop = shift.top;
      shiftLeft = shift.left;
    }

    top += shiftTop;
    left += shiftLeft;

    return { top: top, left: left };
  }
});
return Tether;

}));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "headroom",
    attrs: {
      "id": "header-dep",
      "role": "banner"
    }
  }, [_vm._m(0), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "dep-menu-share"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v("Suivez-nous sur les réseaux sociaux : ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline dep-social-networks"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Departement49",
      "target": "_blank",
      "title": "Page Facebook du Département de Maine-et-Loire [nouvelle fenêtre]"
    }
  }, [_c('span', {
    staticClass: "dep49-icon-facebook",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-facebook"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only sr-only-focusable"
  }, [_vm._v("Page Facebook du Département de Maine-et-Loire")])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/Maine_et_Loire",
      "target": "_blank",
      "title": "Compte Twitter du Département de Maine-et-Loire [nouvelle fenêtre]"
    }
  }, [_c('span', {
    staticClass: "dep49-icon-twitter",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-twitter"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only sr-only-focusable"
  }, [_vm._v("Compte Twitter du Département de Maine-et-Loire")])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/maine_et_loire/",
      "target": "_blank",
      "title": "Compte Instagram du Département de Maine-et-Loire [nouvelle fenêtre]"
    }
  }, [_c('span', {
    staticClass: "dep49-icon-instagram",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-instagram"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only sr-only-focusable"
  }, [_vm._v("Compte Instagram du Département de Maine-et-Loire")])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCbwP1_VTPU2N6ztytUV76qg",
      "target": "_blank",
      "title": "Page Youtube du Département de Maine-et-Loire [nouvelle fenêtre]"
    }
  }, [_c('span', {
    staticClass: "dep49-icon-youtube",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-youtube"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only sr-only-focusable"
  }, [_vm._v("Page Youtube du Département de Maine-et-Loire")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid dep-navigation"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-inline",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('b-dropdown', {
    staticClass: "nav-link",
    attrs: {
      "id": "dep-autres-sites",
      "text": "Nos sites web"
    }
  }, [_c('div', {
    staticClass: "container sitesdep subLevel0"
  }, [_c('ul', {
    staticClass: "subLevel1 active"
  }, [_c('li', [_vm._v("\r\n                  Culture\r\n                  "), _c('div', {
    staticClass: "subLevel2"
  }, [_c('ul', {
    staticClass: "active"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.archives49.fr",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet des Archives départementales (Nouvelle fenêtre)"
    }
  }, [_vm._v("Archives départementales")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.collegiale-saint-martin.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet de la Collégiale Saint-Martin (Nouvelle fenêtre)"
    }
  }, [_vm._v("Collégiale Saint-Martin")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://bibliopole.maine-et-loire.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Bibliopôle (Nouvelle fenêtre)"
    }
  }, [_vm._v("Bibliopôle")])])])])]), _vm._v(" "), _c('li', [_vm._v("\r\n                  Déplacements   \r\n                  "), _c('div', {
    staticClass: "subLevel2"
  }, [_c('ul', {
    staticClass: "active"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.ouestgo.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet OuestGo (Nouvelle fenêtre)"
    }
  }, [_vm._v("Covoiturage")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.inforoutes49.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet Inforoutes49 (Nouvelle fenêtre)"
    }
  }, [_vm._v("Inforoutes49")])])])])]), _vm._v(" "), _c('li', [_vm._v("\r\n                  Services    \r\n                  "), _c('div', {
    staticClass: "subLevel2"
  }, [_c('ul', {
    staticClass: "active"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.anjoumarchespublics.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet Anjou marchés publics (Nouvelle fenêtre)"
    }
  }, [_vm._v("Anjou Marchés publics")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://anjou.e-lyco.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet E-Lyco (Nouvelle fenêtre)"
    }
  }, [_vm._v("E-Lyco")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://data.maine-et-loire.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet data.maine-et-loire.fr (Nouvelle fenêtre)"
    }
  }, [_vm._v("Données publiques")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://participons.maine-et-loire.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet de participation citoyenne (Nouvelle fenêtre)"
    }
  }, [_vm._v("Participation citoyenne")])])])])]), _vm._v(" "), _c('li', [_vm._v("\r\n                  Solidarités   \r\n                  "), _c('div', {
    staticClass: "subLevel2"
  }, [_c('ul', {
    staticClass: "active"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.assistantsmaternels49.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Assistants maternels 49 (Nouvelle fenêtre)"
    }
  }, [_vm._v("Assistants maternels")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://jobanjou.maine-et-loire.fr",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Jobanjou (Nouvelle fenêtre)"
    }
  }, [_vm._v("Jobanjou")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.mda.maine-et-loire.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet de la Maison de l'Autonomie (Nouvelle fenêtre)"
    }
  }, [_vm._v("Maison de l'Autonomie")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://insertion.maine-et-loire.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Portail Insertion (Nouvelle fenêtre)"
    }
  }, [_vm._v("Portail Insertion")])])])])]), _vm._v(" "), _c('li', [_vm._v("\r\n                  Territoire   \r\n                  "), _c('div', {
    staticClass: "subLevel2"
  }, [_c('ul', {
    staticClass: "active"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.eau-anjou.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet de l'Observatoire de l'eau (Nouvelle fenêtre)"
    }
  }, [_vm._v("Observatoire de l'eau")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "http://www.produitenanjou.fr",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet Produit en Anjou (Nouvelle fenêtre)"
    }
  }, [_vm._v("Produit en Anjou")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.parlonsdanjou.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet Parlons d'Anjou (Nouvelle fenêtre)"
    }
  }, [_vm._v("Rayonnement de l'Anjou")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://sentiers.maine-et-loire.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet Sentiers nature (Nouvelle fenêtre)"
    }
  }, [_vm._v("Sentiers nature")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.terrabotanica.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Site Internet de Terra Botanica (Nouvelle fenêtre)"
    }
  }, [_vm._v("Terra Botanica")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://www.wiki-anjou.fr/",
      "target": "_blank",
      "rel": "noreferrer",
      "title": "Wiki-Anjou (Nouvelle fenêtre)"
    }
  }, [_vm._v("Wiki-Anjou")])])])])])]), _vm._v(" "), _c('b-dropdown-item', {
    staticClass: "btn btn-fermer"
  }, [_vm._v("\r\n                  Fermer le menu"), _c('span', {
    staticClass: "dep49-icon-close",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-close",
      "title": "Fermer le menu Actualités"
    }
  })])], 1)])], 1)]), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.dep-menu-share",
      modifiers: {
        "dep-menu-share": true
      }
    }],
    staticClass: "dep-menu-share"
  }, [_c('span', {
    staticClass: "dep49-icon-share",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-share",
      "title": "Ouvrir / Fermer le menu de partage sur les réseaux sociaux"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dep49-icon-arrow-up",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-arrow-up",
      "title": "Ouvrir le menu de partage sur les réseaux sociaux"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dep49-icon-arrow-down",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-arrow-down",
      "title": "Fermer le menu de partage sur les réseaux sociaux"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only sr-only-focusable"
  }, [_vm._v("Ouvrir / Fermer le menu de partage sur les réseaux sociaux")])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid dep-skip-navigation",
    attrs: {
      "id": "dep-skip-navigation",
      "role": "menubar"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, [_c('li', {
    staticClass: "list-inline-item",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('a', {
    staticClass: "skip",
    attrs: {
      "href": "#dep49-contenu"
    }
  }, [_vm._v("Aller au contenu")])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('a', {
    staticClass: "skip",
    attrs: {
      "href": "#dep49-menu"
    }
  }, [_vm._v("Aller au menu")])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('a', {
    staticClass: "skip",
    attrs: {
      "href": "#dep49-recherche"
    }
  }, [_vm._v("Aller à la recherche")])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "id": "headerDyslexia"
    }
  }, [_vm._v("Dyslexie")])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "id": "headerContrast"
    }
  }, [_vm._v("Contraste")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-anjou"
  }, [_c('a', {
    attrs: {
      "href": "https://www.maine-et-loire.fr",
      "target": "_blank",
      "title": "Département de Maine-et-Loire - Anjou : aller à la page d'accueil du site maine-et-loire.fr (Nouvelle fenêtre)"
    }
  }, [_c('span', {
    staticClass: "dep49-icon-logo-anjou",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-logo-anjou",
      "title": "Logo Anjou - Département de Maine-et-Loire"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "https://www.maine-et-loire.fr/aides-et-services",
      "target": "_blank",
      "title": "Rubrique Aides et services du site www.maine-et-loire.fr (Nouvelle fenêtre)"
    }
  }, [_vm._v("Aides et services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "https://www.maine-et-loire.fr/conseil-departemental/",
      "target": "_blank",
      "title": "Rubrique Conseil départemental du site www.maine-et-loire.fr (Nouvelle fenêtre)"
    }
  }, [_vm._v("Conseil départemental")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "https://www.maine-et-loire.fr/actualites/",
      "target": "_blank",
      "title": "Rubrique Actualités du site www.maine-et-loire.fr (Nouvelle fenêtre)"
    }
  }, [_vm._v("Actualités")])])
}]}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-dep",
    attrs: {
      "role": "contentinfo"
    }
  }, [_c('div', {
    staticClass: "container-fluid dep-contact",
    attrs: {
      "itemscope": "",
      "itemtype": "http://schema.org/Organization"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo-anjou",
    attrs: {
      "itemprop": "logo"
    }
  }, [_c('span', {
    staticClass: "dep49-icon-logo-anjou icon-logo-anjou-footer",
    attrs: {
      "aria-hidden": "true",
      "data-glyph": "icon-logo-anjou",
      "title": "Département de Maine-et-Loire - Anjou"
    }
  })]), _vm._v(" "), _c('address', {
    attrs: {
      "itemprop": "contactPoints"
    }
  }, [_c('p', [_c('strong', {
    attrs: {
      "itemprop": "name"
    }
  }, [_vm._v("Département de Maine-et-Loire")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "itemprop": "address"
    }
  }, [_vm._v("\n            CS 94104"), _c('br'), _vm._v("\n            49941 Angers Cedex 9\n          ")])]), _vm._v(" "), _c('p', {
    staticClass: "dep-telephone"
  }, [_c('a', {
    attrs: {
      "href": "https://www.maine-et-loire.fr",
      "itemprop": "url"
    }
  }, [_vm._v("maine-et-loire.fr")]), _vm._v(" "), _c('span', {
    attrs: {
      "itemprop": "telephone"
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:+0241814949",
      "title": "Appeler le Département par téléphone au 02 41 81 49 49"
    }
  }, [_vm._v("02 41 81 49 49")])])])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.maine-et-loire.fr/contacter-le-departement/",
      "target": "_blank",
      "title": "Département de Maine-et-Loire - Anjou : aller au formulaire de contact du site maine-et-loire.fr (Nouvelle fenêtre)"
    }
  }, [_vm._v("Contactez le Département")])])])])
}]}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(11);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b6ec46f0", content, true);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(12);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("13c2e135", content, true);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(13);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0e9545b9", content, true);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(17);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("75a70ad7", content, true);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js